// Outscraper business categories (4275 categories from user-provided list)
export const CATEGORIES = [
  "3D Printing Service",
  "Abbey",
  "Aboriginal And Torres Strait Islander Organisation",
  "Aboriginal Art Gallery",
  "Abortion Clinic",
  "Abrasives Supplier",
  "Abundant Life Church",
  "Accountant",
  "Accounting",
  "Accounting Firm",
  "Accounting School",
  "Accounting Software Company",
  "Acoustical Consultant",
  "Acrobatic Diving Pool",
  "Acrylic Store",
  "Acupuncture Clinic",
  "Acupuncture School",
  "Acupuncturist",
  "Acura Dealer",
  "Addiction Treatment Center",
  "Administrative Attorney",
  "Adoption Agency",
  "Adult Day Care Center",
  "Adult Dvd Store",
  "Adult Education School",
  "Adult Entertainment",
  "Adult Entertainment Club",
  "Adult Entertainment Store",
  "Adult Foster Care Service",
  "Adventure Sports",
  "Adventure Sports Center",
  "Advertising",
  "Advertising Agency",
  "Advertising Service",
  "Aerated Drinks Supplier",
  "Aerial Photographer",
  "Aerial Sports Center",
  "Aero Dance Class",
  "Aerobics Instructor",
  "Aeroclub",
  "Aeromodel Shop",
  "Aeronautical Engineer",
  "Aerospace Company",
  "Afghan Restaurant",
  "Afghani Restaurant",
  "African Goods Store",
  "African Restaurant",
  "After School Program",
  "Aged Care",
  "Agenzia Entrate",
  "Aggregate Supplier",
  "Agistment Service",
  "Agricultural",
  "Agricultural Association",
  "Agricultural Cooperative",
  "Agricultural Engineer",
  "Agricultural High School",
  "Agricultural Machinery Manufacturer",
  "Agricultural Organization",
  "Agricultural Product Wholesaler",
  "Agricultural Production",
  "Agricultural Service",
  "Agricultural Service Supply Agency",
  "Agriculture",
  "Agriculture Cooperative",
  "Agrochemicals Supplier",
  "Aikido Club",
  "Aikido School",
  "Air Compressor Repair Service",
  "Air Compressor Supplier",
  "Air Conditioning Contractor",
  "Air Conditioning Repair Service",
  "Air Conditioning Store",
  "Air Conditioning System Supplier",
  "Air Duct Cleaning Service",
  "Air Filter Supplier",
  "Air Force Base",
  "Air Taxi",
  "Airbrushing Service",
  "Airbrushing Supply Store",
  "Aircraft Dealer",
  "Aircraft Maintenance Company",
  "Aircraft Manufacturer",
  "Aircraft Rental Service",
  "Aircraft Supply Store",
  "Airline",
  "Airline Ticket Agency",
  "Airplane",
  "Airport",
  "Airport Parking Lot",
  "Airport Shuttle Service",
  "Airport Terminal",
  "Airsoft Supply Store",
  "Airstrip",
  "Alcohol Manufacturer",
  "Alcohol Retail Monopoly",
  "Alcoholic Beverage Wholesaler",
  "Alcoholism Treatment Program",
  "Alfa Romeo Dealer",
  "Allergist",
  "Alliance Church",
  "Alsace Restaurant",
  "Alternative Fuel Station",
  "Alternative Medicine",
  "Alternative Medicine Clinic",
  "Alternative Medicine Practitioner",
  "Alternator Supplier",
  "Aluminum Frames Supplier",
  "Aluminum Supplier",
  "Aluminum Welder",
  "Aluminum Window",
  "Alumni Association",
  "Amateur Theater",
  "Ambulance Service",
  "American Football Field",
  "American Grocery Store",
  "American Restaurant",
  "Amish Furniture Store",
  "Ammunition Supplier",
  "Amphitheater",
  "Amusement Center",
  "Amusement Machine Supplier",
  "Amusement Park",
  "Amusement Park Ride",
  "Amusement Ride Supplier",
  "Anesthesiologist",
  "Angler Fish Restaurant",
  "Anglican Church",
  "Animal Control Service",
  "Animal Feed Store",
  "Animal Hospital",
  "Animal Park",
  "Animal Protection Organization",
  "Animal Rescue Service",
  "Animal Shelter",
  "Animal Watering Hole",
  "Animals",
  "Animation Studio",
  "Anime Club",
  "Anodizing Service",
  "Antenna Service",
  "Antique Furniture Restoration Service",
  "Antique Furniture Store",
  "Antique Store",
  "Apartment Building",
  "Apartment Complex",
  "Apartment Rental Agency",
  "Apartments",
  "Apostolic Church",
  "Appliance Parts Supplier",
  "Appliance Rental Service",
  "Appliance Repair Service",
  "Appliance Store",
  "Appliances",
  "Appliances Customer Service",
  "Appraiser",
  "Apprenticeship Center",
  "Aquaculture Farm",
  "Aquarium",
  "Aquarium Shop",
  "Aquatic Centre",
  "Arab Restaurant",
  "Arboretum",
  "Arborist And Tree Surgeon",
  "Archaeological Museum",
  "Archaeological Site",
  "Archery Club",
  "Archery Range",
  "Archery Store",
  "Architect",
  "Architects Association",
  "Architectural And Engineering Model Maker",
  "Architectural Designer",
  "Architectural Salvage Store",
  "Architecture Firm",
  "Architecture School",
  "Archive",
  "Area",
  "Arena",
  "Argentinian Restaurant",
  "Armed Forces Association",
  "Armenian Church",
  "Armenian Restaurant",
  "Army & Navy Surplus Shop",
  "Army Barracks",
  "Army Facility",
  "Army Museum",
  "Aromatherapy Class",
  "Aromatherapy Service",
  "Aromatherapy Supply Store",
  "Art",
  "Art Cafe",
  "Art Center",
  "Art Dealer",
  "Art Gallery",
  "Art Handcraft",
  "Art Museum",
  "Art Restoration Service",
  "Art School",
  "Art Studio",
  "Art Supply Store",
  "Artificial Plant Supplier",
  "Artist",
  "Artistic Handicrafts",
  "Arts Organization",
  "Asbestos Testing Service",
  "Ashram",
  "Asian Fusion Restaurant",
  "Asian Grocery Store",
  "Asian Household Goods Store",
  "Asian Restaurant",
  "Asphalt Contractor",
  "Asphalt Mixing Plant",
  "Assemblies Of God Church",
  "Assembly Hall",
  "Assembly Room",
  "Assistante Maternelle",
  "Assisted Living Facility",
  "Association Or Organisation",
  "Association Or Organization",
  "Aston Martin Dealer",
  "Astrologer",
  "Athletic Club",
  "Athletic Field",
  "Athletic Park",
  "Athletic Track",
  "Atm",
  "Attorney",
  "Attorney Referral Service",
  "Attraction",
  "Atv Dealer",
  "Atv Rental Service",
  "Atv Repair Shop",
  "Auction House",
  "Audi Dealer",
  "Audio Visual Consultant",
  "Audio Visual Equipment Rental Service",
  "Audio Visual Equipment Repair Service",
  "Audio Visual Equipment Supplier",
  "Audiologist",
  "Audiovisual Equipment Rental Service",
  "Auditor",
  "Auditorium",
  "Australian Goods Store",
  "Australian Restaurant",
  "Austrian Restaurant",
  "Authentic Japanese Restaurant",
  "Auto Accessories Wholesaler",
  "Auto Air Conditioning Service",
  "Auto Auction",
  "Auto Body Parts Supplier",
  "Auto Body Shop",
  "Auto Bodywork Mechanic",
  "Auto Broker",
  "Auto Chemistry Shop",
  "Auto Dent Removal Service",
  "Auto Electrical Service",
  "Auto Glass Repair Service",
  "Auto Glass Shop",
  "Auto Insurance Agency",
  "Auto Machine Shop",
  "Auto Market",
  "Auto Painting",
  "Auto Parts Manufacturer",
  "Auto Parts Market",
  "Auto Parts Store",
  "Auto Radiator Repair Service",
  "Auto Repair Shop",
  "Auto Restoration Service",
  "Auto Spring Shop",
  "Auto Sunroof Shop",
  "Auto Tag Agency",
  "Auto Tune Up Service",
  "Auto Upholsterer",
  "Auto Window Tinting Service",
  "Auto Wrecker",
  "Automation Company",
  "Automobile Storage Facility",
  "Automotive",
  "Aviation",
  "Aviation Consultant",
  "Aviation Training Institute",
  "Awning Supplier",
  "Ayurvedic Clinic",
  "Açaí Shop",
  "Baby Clothing Store",
  "Baby Store",
  "Baby Swimming School",
  "Back Office",
  "Badminton Club",
  "Badminton Complex",
  "Badminton Court",
  "Bag Shop",
  "Bagel Shop",
  "Bahá\'Í House Of Worship",
  "Bail Bonds Service",
  "Bailiff",
  "Bait Shop",
  "Bakery",
  "Bakery Equipment",
  "Baking Supply Store",
  "Ballet School",
  "Ballet Theater",
  "Balloon Artist",
  "Balloon Ride Tour Agency",
  "Balloon Store",
  "Ballroom",
  "Ballroom Dance Instructor",
  "Band",
  "Bangladeshi Restaurant",
  "Bank",
  "Bank Or Atm",
  "Banking And Finance",
  "Bankruptcy Attorney",
  "Bankruptcy Service",
  "Banner Store",
  "Banquet Hall",
  "Baptist Church",
  "Bar",
  "Bar & Grill",
  "Bar Pmu",
  "Bar Restaurant Furniture Store",
  "Bar Stool Supplier",
  "Bar Tabac",
  "Barbecue Area",
  "Barbecue Restaurant",
  "Barber School",
  "Barber Shop",
  "Barber Supply Store",
  "Bariatric Surgeon",
  "Bark Supplier",
  "Barrel Supplier",
  "Barrister",
  "Bartending School",
  "Baseball",
  "Baseball Club",
  "Baseball Field",
  "Baseball Goods Store",
  "Basilica",
  "Basket Supplier",
  "Basketball",
  "Basketball Club",
  "Basketball Court",
  "Basketball Court Contractor",
  "Basque Restaurant",
  "Bathroom Remodeler",
  "Bathroom Supply Store",
  "Batik Clothing Store",
  "Battery Manufacturer",
  "Battery Store",
  "Battery Wholesaler",
  "Batting Cage Center",
  "Battle Site",
  "Bay",
  "Bazar",
  "Bbq Area",
  "Beach",
  "Beach Cleaning Service",
  "Beach Clothing Store",
  "Beach Entertainment Shop",
  "Beach Pavillion",
  "Beach Volleyball Club",
  "Beach Volleyball Court",
  "Bead Store",
  "Bead Wholesaler",
  "Bearing Supplier",
  "Beautician",
  "Beauty",
  "Beauty Product Supplier",
  "Beauty Products Vending Machine",
  "Beauty Products Wholesaler",
  "Beauty Salon",
  "Beauty School",
  "Beauty Supply Store",
  "Bed & Breakfast",
  "Bed Shop",
  "Bedding Store",
  "Bedroom Furniture Store",
  "Beer Distributor",
  "Beer Garden",
  "Beer Hall",
  "Beer Store",
  "Belgian Restaurant",
  "Belt Shop",
  "Bentley Dealer",
  "Betting Agency",
  "Beverage Distributor",
  "Beverage Supplier",
  "Beverages",
  "Bicycle Club",
  "Bicycle Rack",
  "Bicycle Rental Service",
  "Bicycle Repair Shop",
  "Bicycle Shop",
  "Bicycle Store",
  "Bicycle Wholesale",
  "Bicycle Wholesaler",
  "Bicycles",
  "Bike Sharing Station",
  "Bike Wash",
  "Biking Trail",
  "Bikram Yoga Studio",
  "Bilingual School",
  "Billiards Supply Store",
  "Bingo Hall",
  "Biochemical Supplier",
  "Biochemistry Lab",
  "Biofeedback Therapist",
  "Biotechnology Company",
  "Biotechnology Engineer",
  "Bird Control Service",
  "Bird Shop",
  "Bird Watching Area",
  "Birth Center",
  "Birth Certificate Service",
  "Birth Control Center",
  "Biryani Restaurant",
  "Bistro",
  "Blacksmith",
  "Blast Cleaning Service",
  "Blind School",
  "Blinds Shop",
  "Blood Bank",
  "Blood Donation Center",
  "Blood Testing Service",
  "Blueprint Service",
  "Blues Club",
  "Bmw Dealer",
  "Bmw Motorcycle Dealer",
  "Bmx Club",
  "Bmx Park",
  "Bmx Track",
  "Board Game Club",
  "Board Of Education",
  "Board Of Trade",
  "Boarding House",
  "Boarding School",
  "Boat Accessories Supplier",
  "Boat Builders",
  "Boat Club",
  "Boat Cover Supplier",
  "Boat Dealer",
  "Boat Ramp",
  "Boat Rental Service",
  "Boat Repair Shop",
  "Boat Storage Facility",
  "Boat Tour Agency",
  "Boat Trailer Dealer",
  "Boating Instructor",
  "Bocce Ball Court",
  "Body Arts",
  "Body Piercing Shop",
  "Body Shaping Class",
  "Boiler Manufacturer",
  "Boiler Supplier",
  "Bonesetting House",
  "Bonsai Plant Supplier",
  "Book Publisher",
  "Book Store",
  "Bookbinder",
  "Bookkeeping Service",
  "Bookmaker",
  "Books Wholesaler",
  "Boot Camp",
  "Boot Repair Shop",
  "Boot Store",
  "Border Crossing Station",
  "Border Guard",
  "Botanical Garden",
  "Bottle & Can Redemption Center",
  "Bottled Water Supplier",
  "Bouncy Castle Hire",
  "Boutique",
  "Bowling Alley",
  "Bowling Club",
  "Bowling Supply Shop",
  "Box Lunch Restaurant",
  "Box Lunch Supplier",
  "Boxing Club",
  "Boxing Gym",
  "Boxing Ring",
  "Boys\' High School",
  "Bpo Company",
  "Bpo Placement Agency",
  "Brake Shop",
  "Brasserie",
  "Brazilian Pastelaria",
  "Brazilian Restaurant",
  "Breakfast Restaurant",
  "Breeding",
  "Brewery",
  "Brewing Supply Store",
  "Brewpub",
  "Brick Manufacturer",
  "Bricklayer",
  "Bridal Shop",
  "Bridge",
  "Bridge Club",
  "British Restaurant",
  "Brunch Restaurant",
  "Bubble Tea Store",
  "Buddhist Supplies Store",
  "Buddhist Temple",
  "Buffet Restaurant",
  "Bugatti Dealer",
  "Buick Dealer",
  "Builder",
  "Building",
  "Building Consultant",
  "Building Design Company",
  "Building Designer",
  "Building Equipment Hire Service",
  "Building Firm",
  "Building Inspector",
  "Building Lots Sales Agency",
  "Building Materials Market",
  "Building Materials Store",
  "Building Materials Supplier",
  "Building Restoration Service",
  "Building Society",
  "Bulgarian Restaurant",
  "Bullring",
  "Bungee Jumping Center",
  "Burglar Alarm Store",
  "Burmese Restaurant",
  "Burrito Restaurant",
  "Bus And Coach Company",
  "Bus And Coach Station",
  "Bus Charter",
  "Bus Company",
  "Bus Depot",
  "Bus Station",
  "Bus Stop",
  "Bus Ticket Agency",
  "Bus Tour Agency",
  "Buses",
  "Business Administration Service",
  "Business Banking Service",
  "Business Broker",
  "Business Card Design And Printing Service",
  "Business Center",
  "Business Development Service",
  "Business Management Consultant",
  "Business Networking Company",
  "Business Park",
  "Business Related",
  "Business School",
  "Business To Business Service",
  "Butane Gas Supplier",
  "Butcher Shop",
  "Butcher Shop Deli",
  "Cabaret Club",
  "Cabin Rental Agency",
  "Cabinet Maker",
  "Cabinet Store",
  "Cable Car Station",
  "Cable Company",
  "Cadillac Dealer",
  "Cafe",
  "Cafeteria",
  "Cajun Restaurant",
  "Cake Decorating Equipment Shop",
  "Cake Shop",
  "Californian Restaurant",
  "Call Center",
  "Call Shop",
  "Calligraphy Lesson",
  "Calvary Chapel Church",
  "Cambodian Restaurant",
  "Camera Repair Shop",
  "Camera Store",
  "Camp",
  "Camper Shell Supplier",
  "Campground",
  "Camping Cabin",
  "Camping Farm",
  "Camping Store",
  "Canadian Restaurant",
  "Canal",
  "Cancer Treatment Center",
  "Candle Store",
  "Candy Store",
  "Cane Furniture Store",
  "Cannabis Club",
  "Cannabis Store",
  "Cannery",
  "Canoe & Kayak Rental Service",
  "Canoe & Kayak Store",
  "Canoe & Kayak Tour Agency",
  "Canoe And Kayak Club",
  "Canoeing Area",
  "Cantonese Restaurant",
  "Cape Verdean Restaurant",
  "Capoeira School",
  "Capsule Hotel",
  "Car Accessories Store",
  "Car Alarm Supplier",
  "Car Battery Store",
  "Car Dealer",
  "Car Detailing Service",
  "Car Factory",
  "Car Finance And Loan Company",
  "Car Inspection Station",
  "Car Leasing Service",
  "Car Manufacturer",
  "Car Racing Track",
  "Car Rental",
  "Car Rental Agency",
  "Car Repair And Maintenance",
  "Car Repair And Maintenance Service",
  "Car Security System Installer",
  "Car Service",
  "Car Sharing Location",
  "Car Stereo Store",
  "Car Wash",
  "Cardiologist",
  "Cardiovascular And Thoracic Surgeon",
  "Care Services",
  "Career Guidance Service",
  "Caribbean Restaurant",
  "Carnival Club",
  "Carpenter",
  "Carpet Cleaning Service",
  "Carpet Installer",
  "Carpet Manufacturer",
  "Carpet Store",
  "Carpet Wholesaler",
  "Carpool",
  "Carport And Pergola Builder",
  "Carriage Ride Service",
  "Cars",
  "Carvery",
  "Cash And Carry Wholesaler",
  "Cashpoint",
  "Casino",
  "Casket Service",
  "Castilian Restaurant",
  "Castle",
  "Cat Boarding Service",
  "Cat Breeder",
  "Cat Trainer",
  "Caterer",
  "Catering",
  "Catering Food And Drink Supplier",
  "Cathedral",
  "Catholic Cathedral",
  "Catholic Church",
  "Catholic School",
  "Cattery",
  "Cattle Farm",
  "Cattle Market",
  "Cave",
  "Cbse School",
  "Cd Store",
  "Ceiling Supplier",
  "Cell Phone Accessory Store",
  "Cell Phone Charging Station",
  "Cell Phone Store",
  "Cement Manufacturer",
  "Cement Supplier",
  "Cemetery",
  "Central American Restaurant",
  "Central Authority",
  "Central Bank",
  "Ceramic Manufacturer",
  "Ceramics Wholesaler",
  "Certification Agency",
  "Certified Public Accountant",
  "Cha Chaan Teng (Hong Kong-Style Cafe)",
  "Chalet",
  "Chamber Of Agriculture",
  "Chamber Of Commerce",
  "Chamber Of Handicrafts",
  "Channel",
  "Chapel",
  "Charcuterie",
  "Charity",
  "Charter School",
  "Chartered Accountant",
  "Chauffeur Service",
  "Check Cashing Service",
  "Cheese Manufacturer",
  "Cheese Shop",
  "Cheesesteak Restaurant",
  "Chemical Engineer",
  "Chemical Exporter",
  "Chemical Industry",
  "Chemical Manufacturer",
  "Chemical Plant",
  "Chemical Wholesaler",
  "Chemistry Faculty",
  "Chemistry Lab",
  "Chess And Card Club",
  "Chess Club",
  "Chess Instructor",
  "Chevrolet Dealer",
  "Chicken Hatchery",
  "Chicken Restaurant",
  "Chicken Shop",
  "Chicken Wings Restaurant",
  "Child Care Agency",
  "Child Health Care Centre",
  "Child Psychiatrist",
  "Child Psychologist",
  "Childbirth Class",
  "Childminder",
  "Children Hall",
  "Children Policlinic",
  "Children\'S Amusement Center",
  "Children\'S Camp",
  "Children\'S Clothing Store",
  "Children\'S Farm",
  "Children\'S Furniture Store",
  "Children\'S Health Service",
  "Children\'S Hospital",
  "Children\'S Museum",
  "Children\'S Party Service",
  "Childrens Book Store",
  "Childrens Cafe",
  "Childrens Club",
  "Childrens Farm",
  "Childrens Home",
  "Childrens Library",
  "Childrens Party Buffet",
  "Childrens Store",
  "Childrens Theater",
  "Chilean Restaurant",
  "Chimney Services",
  "Chimney Sweep",
  "Chinaware Store",
  "Chinese Bakery",
  "Chinese Language Instructor",
  "Chinese Language School",
  "Chinese Medicine Clinic",
  "Chinese Medicine Store",
  "Chinese Noodle Restaurant",
  "Chinese Restaurant",
  "Chinese Supermarket",
  "Chinese Takeaway",
  "Chinese Tea House",
  "Chiropractor",
  "Chocolate Artisan",
  "Chocolate Cafe",
  "Chocolate Factory",
  "Chocolate Shop",
  "Choir",
  "Chophouse Restaurant",
  "Christian Book Store",
  "Christian Church",
  "Christian College",
  "Christmas Market",
  "Christmas Store",
  "Christmas Tree Farm",
  "Chrysler Dealer",
  "Church",
  "Church Of Christ",
  "Church Of Jesus Christ Of Latter-Day Saints",
  "Church Of The Nazarene",
  "Church Supply Store",
  "Churreria",
  "Cider Bar",
  "Cider Mill",
  "Cigar Shop",
  "Cigarette Vending Machine",
  "Cinema Equipment Supplier",
  "Circular Distribution Service",
  "Circus",
  "Citizen Information Bureau",
  "Citizens Advice Bureau",
  "City Administration",
  "City Clerk\'S Office",
  "City Courthouse",
  "City Department Of Environment",
  "City Department Of Public Safety",
  "City Department Of Transportation",
  "City District Office",
  "City Employment Department",
  "City Government Office",
  "City Hall",
  "City Or Town Hall",
  "City Park",
  "City Pillar Shrine",
  "City Tax Office",
  "Civic Center",
  "Civil Defense",
  "Civil Engineer",
  "Civil Engineering Company",
  "Civil Examinations Academy",
  "Civil Law Attorney",
  "Civil Police",
  "Class",
  "Classified Ads Newspaper Publisher",
  "Cleaners",
  "Cleaning Products Supplier",
  "Cleaning Service",
  "Clergyman",
  "Cliff",
  "Clock Repair Service",
  "Clock Watch Maker",
  "Closed Circuit Television",
  "Clothes And Fabric Manufacturer",
  "Clothes And Fabric Wholesaler",
  "Clothes Market",
  "Clothing",
  "Clothing Alteration Service",
  "Clothing Manufacturer",
  "Clothing Shop",
  "Clothing Store",
  "Clothing Supplier",
  "Clothing Wholesale Market Place",
  "Clothing Wholesaler",
  "Club",
  "Cng Fitment Center",
  "Cng Fittment Center",
  "Co-Ed School",
  "Coaching",
  "Coaching Center",
  "Coaching Service",
  "Coal Exporter",
  "Coal Supplier",
  "Coalfield",
  "Coast Guard Station",
  "Cocktail Bar",
  "Coffee Machine Supplier",
  "Coffee Roasters",
  "Coffee Shop",
  "Coffee Stand",
  "Coffee Store",
  "Coffee Vending Machine",
  "Coffee Wholesaler",
  "Coffin Supplier",
  "Coin Cashing Machine",
  "Coin Dealer",
  "Coin Operated Laundry Equipment Supplier",
  "Coin Operated Locker",
  "Cold Cut Store",
  "Cold Storage Facility",
  "Collectibles Store",
  "College",
  "College Of Agriculture",
  "Colombian Restaurant",
  "Combined Primary And Secondary School",
  "Comedy Club",
  "Comic Book Store",
  "Comic Cafe",
  "Commercial Agent",
  "Commercial Cleaning Service",
  "Commercial Photographer",
  "Commercial Printer",
  "Commercial Real Estate Agency",
  "Commercial Real Estate Inspector",
  "Commercial Refrigeration",
  "Commercial Refrigerator Supplier",
  "Commissioner For Oaths",
  "Communications Central",
  "Communications Tower",
  "Community Center",
  "Community College",
  "Community Garden",
  "Community Health Centre",
  "Community School",
  "Community Service",
  "Company",
  "Company Registry",
  "Compressed Natural Gas Station",
  "Computer Accessories Store",
  "Computer Club",
  "Computer Consultant",
  "Computer Desk Store",
  "Computer Hardware Manufacturer",
  "Computer Networking Center",
  "Computer Networking Service",
  "Computer Repair Service",
  "Computer Security Service",
  "Computer Service",
  "Computer Software Store",
  "Computer Store",
  "Computer Support And Services",
  "Computer Training School",
  "Computer Wholesaler",
  "Computers",
  "Concert Hall",
  "Concrete Contractor",
  "Concrete Factory",
  "Concrete Metal Framework Supplier",
  "Concrete Product Supplier",
  "Condiments Supplier",
  "Condominium Complex",
  "Condominium Rental Agency",
  "Confectionery",
  "Confectionery Wholesaler",
  "Conference Center",
  "Congregation",
  "Conservation Department",
  "Conservative Club",
  "Conservative Synagogue",
  "Conservatory Construction Contractor",
  "Conservatory Of Music",
  "Conservatory Supply & Installation",
  "Consignment Shop",
  "Construction",
  "Construction And Maintenance Office",
  "Construction Company",
  "Construction Equipment Supplier",
  "Construction Machine Dealer",
  "Construction Machine Rental Service",
  "Construction Material Wholesaler",
  "Consultant",
  "Consumer Advice Center",
  "Contact Lenses Supplier",
  "Container Service",
  "Container Supplier",
  "Container Terminal",
  "Containers Supplier",
  "Contemporary Louisiana Restaurant",
  "Continental Restaurant",
  "Contractor",
  "Convenience Store",
  "Convenience Stores Organization",
  "Convent",
  "Convention Center",
  "Convention Information Bureau",
  "Conveyor Belt Sushi Restaurant",
  "Cookie Shop",
  "Cooking Class",
  "Cooking School",
  "Cooling Plant",
  "Cooperative",
  "Copier Repair Service",
  "Copper Supplier",
  "Coppersmith",
  "Copy Shop",
  "Copying Supply Store",
  "Corporate Campus",
  "Corporate Entertainment Service",
  "Corporate Gift Supplier",
  "Corporate Office",
  "Correctional Services Department",
  "Cosmetic Dentist",
  "Cosmetic Products Manufacturer",
  "Cosmetic Surgeon",
  "Cosmetics",
  "Cosmetics And Perfumes Supplier",
  "Cosmetics Industry",
  "Cosmetics Store",
  "Cosmetics Wholesaler",
  "Cosplay Cafe",
  "Costa Rican Restaurant",
  "Costume Jewelry Shop",
  "Costume Rental Service",
  "Costume Store",
  "Cottage",
  "Cottage Rental",
  "Cottage Village",
  "Cotton Exporter",
  "Cotton Mill",
  "Cotton Supplier",
  "Council",
  "Counsellor",
  "Counselor",
  "Countertop Contractor",
  "Countertop Store",
  "Country Club",
  "Country Food Restaurant",
  "Country House",
  "Country Park",
  "County Court",
  "County Government Office",
  "Courier Service",
  "Court Executive Officer",
  "Court Reporter",
  "Courthouse",
  "Couture Store",
  "Coworking Space",
  "Crab House",
  "Craft Store",
  "Cramming School",
  "Crane Dealer",
  "Crane Rental Agency",
  "Crane Service",
  "Craniosacral Therapy",
  "Crater",
  "Creche",
  "Credit Counseling Service",
  "Credit Reporting Agency",
  "Credit Union",
  "Cremation Service",
  "Creole Restaurant",
  "Creperie",
  "Cricket Club",
  "Cricket Ground",
  "Cricket Shop",
  "Crime Victim Service",
  "Criminal Court",
  "Criminal Justice Attorney",
  "Crisis Center",
  "Crop Grower",
  "Croquet Club",
  "Cruise Agency",
  "Cruise Line Company",
  "Cruise Terminal",
  "Crushed Stone Supplier",
  "Crypto Atm",
  "Crêperie",
  "Cuban Restaurant",
  "Cue Sports School",
  "Culinary School",
  "Cultural Association",
  "Cultural Center",
  "Cultural Landmark",
  "Culture",
  "Cupcake Shop",
  "Cured Ham Store",
  "Curling Club",
  "Currency Exchange Service",
  "Curtain And Upholstery Cleaning Service",
  "Curtain Store",
  "Curtain Supplier And Maker",
  "Custom Confiscated Goods Store",
  "Custom Home Builder",
  "Custom Label Printer",
  "Custom T-Shirt Store",
  "Custom Tailor",
  "Customs Broker",
  "Customs Consultant",
  "Customs Department",
  "Customs Office",
  "Customs Warehouse",
  "Cutlery Store",
  "Cycling Park",
  "Czech Restaurant",
  "Dairy",
  "Dairy Farm",
  "Dairy Farm Equipment Supplier",
  "Dairy Store",
  "Dairy Supplier",
  "Dam",
  "Dance Club",
  "Dance Company",
  "Dance Conservatory",
  "Dance Hall",
  "Dance Pavillion",
  "Dance Restaurant",
  "Dance School",
  "Dance Store",
  "Dancing",
  "Danish Restaurant",
  "Dart Bar",
  "Dart Supply Store",
  "Data Entry Service",
  "Data Recovery Service",
  "Database Management Company",
  "Dating Service",
  "Day Care Center",
  "Day Spa",
  "Deaf Church",
  "Deaf Service",
  "Dealer Of Fiat Professional",
  "Debris Removal Service",
  "Debt Collecting",
  "Debt Collection Agency",
  "Decal Supplier",
  "Deck Builder",
  "Deli",
  "Delivery Chinese Restaurant",
  "Delivery Restaurant",
  "Delivery Service",
  "Demolition Contractor",
  "Dental",
  "Dental Clinic",
  "Dental Hygienist",
  "Dental Implants Periodontist",
  "Dental Implants Provider",
  "Dental Insurance Agency",
  "Dental Laboratory",
  "Dental Radiology",
  "Dental School",
  "Dental Supply Store",
  "Dentist",
  "Denture Care Center",
  "Department For Regional Development",
  "Department Of Education",
  "Department Of Finance",
  "Department Of Housing",
  "Department Of Motor Vehicles",
  "Department Of Public Safety",
  "Department Of Social Services",
  "Department Of State Treasure",
  "Department Of Transportation",
  "Department Store",
  "Dept Of City Treasure",
  "Dermatologist",
  "Desalination Plant",
  "Desert",
  "Design",
  "Design Agency",
  "Design Engineer",
  "Design Institute",
  "Designer",
  "Designer Clothing Store",
  "Desktop Publishing Service",
  "Dessert Restaurant",
  "Dessert Shop",
  "Detective",
  "Detention Center",
  "Diabetes Center",
  "Diabetes Equipment Supplier",
  "Diabetologist",
  "Diagnostic Center",
  "Dialysis Center",
  "Diamond Buyer",
  "Diamond Dealer",
  "Diaper Service",
  "Diesel Engine Dealer",
  "Diesel Engine Repair Service",
  "Diesel Fuel Supplier",
  "Dietitian",
  "Digital Printer",
  "Digital Printing Service",
  "Dim Sum Restaurant",
  "Diner",
  "Dinner Theater",
  "Direct Mail Advertising",
  "Dirt Supplier",
  "Disability Equipment Supplier",
  "Disability Services",
  "Disability Services & Support Organisation",
  "Disability Services And Support Organization",
  "Disabled Sports Center",
  "Disc Golf Course",
  "Disciples Of Christ Church",
  "Disco Club",
  "Discount Store",
  "Discount Supermarket",
  "Display Home Centre",
  "Display Stand Manufacturer",
  "Disposable Tableware Supplier",
  "Distance Learning Center",
  "Distillery",
  "Distributary",
  "Distribution Service",
  "Distributors",
  "District Attorney",
  "District Council",
  "District Court",
  "District Government Office",
  "District Justice",
  "District Office",
  "Dive Club",
  "Dive Shop",
  "Diving Center",
  "Diving Contractor",
  "Divorce Lawyer",
  "Divorce Service",
  "Dj Service",
  "Dj Supply Store",
  "Do-It-Yourself Shop",
  "Dock Builder",
  "Doctor",
  "Dodge Dealer",
  "Dog Breeder",
  "Dog Cafe",
  "Dog Care",
  "Dog Day Care Center",
  "Dog Hostel",
  "Dog Park",
  "Dog Trainer",
  "Dog Walker",
  "Dogsled Ride Service",
  "Dojo Restaurant",
  "Doll Restoration Service",
  "Doll Store",
  "Dollar Store",
  "Domestic Abuse Treatment Center",
  "Domestic Airport",
  "Domestic Services",
  "Dominican Restaurant",
  "Donations Center",
  "Doner Kebab Restaurant",
  "Donut Shop",
  "Door Manufacturer",
  "Door Shop",
  "Door Supplier",
  "Door Warehouse",
  "Double Glazing Installer",
  "Doula",
  "Down Home Cooking Restaurant",
  "Drafting Equipment Supplier",
  "Drafting Service",
  "Drainage Service",
  "Drama School",
  "Drama Theater",
  "Drawing Lessons",
  "Dress And Tuxedo Rental Service",
  "Dress Store",
  "Dressmaker",
  "Dried Flower Shop",
  "Dried Seafood Store",
  "Drilling Contractor",
  "Drilling Equipment Supplier",
  "Drinking Water",
  "Drinking Water Dispenser",
  "Drinking Water Fountain",
  "Drive-In Movie Theater",
  "Driver And Vehicle Licensing Agency",
  "Driver\'S License Office",
  "Drivers License Training School",
  "Driveshaft Shop",
  "Driving School",
  "Driving Test Center",
  "Driving Test Centre",
  "Drone Shop",
  "Drug Store",
  "Drug Testing Service",
  "Drum School",
  "Drum Store",
  "Dry Cleaner",
  "Dry Fruit Store",
  "Dry Ice Supplier",
  "Dry Wall Contractor",
  "Dry Wall Supply Store",
  "Dryer Vent Cleaning Service",
  "Ds Automobiles Dealer",
  "Ducati Dealer",
  "Dude Ranch",
  "Dump Truck Dealer",
  "Dumpling Restaurant",
  "Dumpster Rental Service",
  "Dune",
  "Dutch Restaurant",
  "Duty Free Store",
  "Dvd Store",
  "Dye Store",
  "Dyeworks",
  "Dynamometer Supplier",
  "E Commerce Agency",
  "E-Commerce Service",
  "Ear Piercing Service",
  "Earth Works Company",
  "East African Restaurant",
  "Eastern European Restaurant",
  "Eastern Orthodox Church",
  "Eatery",
  "Eating Disorder Treatment Center",
  "Eclectic Restaurant",
  "Ecological Park",
  "Ecologists Association",
  "Economic Consultant",
  "Economic Development Agency",
  "Ecuadorian Restaurant",
  "Education",
  "Education And Culture",
  "Education Center",
  "Educational Consultant",
  "Educational Institution",
  "Educational Supply Store",
  "Educational Testing Service",
  "Eftpos Equipment Supplier",
  "Egg Supplier",
  "Egyptian Restaurant",
  "Elder Law Attorney",
  "Electric Bicycle Store",
  "Electric Motor Repair Shop",
  "Electric Motor Scooter Dealer",
  "Electric Motor Store",
  "Electric Motor Vehicle Dealer",
  "Electric Utility Company",
  "Electric Utility Manufacturer",
  "Electric Vehicle Charging Station",
  "Electric Vehicle Charging Station Contractor",
  "Electrical Appliance Wholesaler",
  "Electrical Engineer",
  "Electrical Equipment Manufacturer",
  "Electrical Equipment Supplier",
  "Electrical Installation Service",
  "Electrical Repair Shop",
  "Electrical Substation",
  "Electrical Supply Store",
  "Electrical Wholesaler",
  "Electrician",
  "Electrolysis Hair Removal Service",
  "Electronic Engineer",
  "Electronic Parts Supplier",
  "Electronics",
  "Electronics Accessories Wholesaler",
  "Electronics Company",
  "Electronics Engineer",
  "Electronics Exporter",
  "Electronics Hire Shop",
  "Electronics Manufacturer",
  "Electronics Repair Shop",
  "Electronics Store",
  "Electronics Vending Machine",
  "Electronics Wholesaler",
  "Elementary School",
  "Elevated",
  "Elevator Manufacturer",
  "Elevator Service",
  "Embassy",
  "Embossing Service",
  "Embroidery Service",
  "Embroidery Shop",
  "Emergency Call Booth",
  "Emergency Care Physician",
  "Emergency Care Service",
  "Emergency Dental Service",
  "Emergency Locksmith Service",
  "Emergency Management Ministry",
  "Emergency Room",
  "Emergency Services",
  "Emergency Training",
  "Emergency Training School",
  "Emergency Veterinarian Service",
  "Employment Agency",
  "Employment Attorney",
  "Employment Center",
  "Employment Consultant",
  "Employment Search Service",
  "Employment Services",
  "Endocrinologist",
  "Endodontist",
  "Endoscopist",
  "Energy Equipment And Solutions",
  "Energy Supplier",
  "Engine Rebuilding Service",
  "Engineer",
  "Engineering Consultant",
  "Engineering School",
  "English Language Camp",
  "English Language Instructor",
  "English Language School",
  "English Restaurant",
  "Engraver",
  "Entertainer",
  "Entertainment",
  "Entertainment Agency",
  "Entertainment And Recreation",
  "Envelope Supplier",
  "Environment Office",
  "Environment Renewable Natural Resources",
  "Environmental Consultant",
  "Environmental Engineer",
  "Environmental Health Service",
  "Environmental Organization",
  "Environmental Program",
  "Environmental Protection Organization",
  "Episcopal Church",
  "Equestrian Club",
  "Equestrian Facility",
  "Equestrian Store",
  "Equipment Exporter",
  "Equipment Importer",
  "Equipment Rental Agency",
  "Equipment Supplier",
  "Eritrean Restaurant",
  "Escape Room Center",
  "Escrow Service",
  "Espresso Bar",
  "Establishment",
  "Estate Agent",
  "Estate Appraiser",
  "Estate Liquidator",
  "Estate Planning Attorney",
  "Estuary",
  "Ethiopian Restaurant",
  "Ethnic Restaurant",
  "Ethnographic Museum",
  "European Restaurant",
  "Evangelical Church",
  "Evening Dress Rental Service",
  "Event Management Company",
  "Event Planner",
  "Event Technology Service",
  "Event Ticket Seller",
  "Event Venue",
  "Excavating Contractor",
  "Executive Search Firm",
  "Executive Suite Rental Agency",
  "Executor",
  "Exercise Equipment Store",
  "Exhibit",
  "Exhibition And Trade Centre",
  "Exhibition Planner",
  "Exporter",
  "Extended Stay Hotel",
  "Eye Care",
  "Eye Care Center",
  "Eyebrow Bar",
  "Eyelash Salon",
  "Fabric Product Manufacturer",
  "Fabric Store",
  "Fabric Wholesaler",
  "Fabrication Engineer",
  "Facial Spa",
  "Factory Equipment Supplier",
  "Faculty Of Arts",
  "Faculty Of Law",
  "Faculty Of Pharmacy",
  "Faculty Of Psychology",
  "Faculty Of Science",
  "Faculty Of Sports",
  "Fair",
  "Fair Trade Organization",
  "Fairground",
  "Falafel Restaurant",
  "Family Counselor",
  "Family Court",
  "Family Day Care Service",
  "Family Law Attorney",
  "Family Planning Center",
  "Family Planning Counselor",
  "Family Practice Physician",
  "Family Restaurant",
  "Family Service Center",
  "Farm",
  "Farm Bureau",
  "Farm Equipment Repair Service",
  "Farm Equipment Supplier",
  "Farm Household Tour",
  "Farm School",
  "Farm Shop",
  "Farmers\' Market",
  "Farming And Cattle Raising",
  "Farmstay",
  "Fashion",
  "Fashion Accessories Store",
  "Fashion Design School",
  "Fashion Designer",
  "Fast Food Restaurant",
  "Fastener Supplier",
  "Favela",
  "Fax Service",
  "Federal Agency For Technical Relief",
  "Federal Courthouse",
  "Federal Credit Union",
  "Federal Government Office",
  "Federal Police",
  "Federal Reserve Bank",
  "Feed Manufacturer",
  "Felt Boots Store",
  "Fence Contractor",
  "Fence Supply Store",
  "Fencing Salon",
  "Fencing School",
  "Feng Shui Consultant",
  "Feng Shui Shop",
  "Ferrari Dealer",
  "Ferris Wheel",
  "Ferry Service",
  "Ferry Terminal",
  "Fertility Clinic",
  "Fertility Physician",
  "Fertilizer Supplier",
  "Festival",
  "Festival Hall",
  "Fiat Dealer",
  "Fiber Optic Products Supplier",
  "Fiberglass Repair Service",
  "Fiberglass Supplier",
  "Figurine Shop",
  "Filipino Grocery Store",
  "Filipino Restaurant",
  "Film And Photograph Library",
  "Film Production Company",
  "Filtration Plant",
  "Finance Broker",
  "Financial Advisor",
  "Financial Audit",
  "Financial Consultant",
  "Financial Institution",
  "Financial Planner",
  "Fine Dining Restaurant",
  "Fingerprinting Service",
  "Finishing Materials Supplier",
  "Fire Alarm Supplier",
  "Fire Damage Restoration Service",
  "Fire Department Equipment Supplier",
  "Fire Extinguisher",
  "Fire Fighters Academy",
  "Fire Protection Consultant",
  "Fire Protection Equipment Supplier",
  "Fire Protection Service",
  "Fire Protection System Supplier",
  "Fire Station",
  "Firearms Academy",
  "Fireplace Manufacturer",
  "Fireplace Store",
  "Firewood Supplier",
  "Fireworks Store",
  "Fireworks Supplier",
  "First Aid Station",
  "Fish & Chips Restaurant",
  "Fish And Chips Takeaway",
  "Fish Farm",
  "Fish Processing",
  "Fish Restaurant",
  "Fish Spa",
  "Fish Store",
  "Fishing",
  "Fishing Area",
  "Fishing Camp",
  "Fishing Charter",
  "Fishing Club",
  "Fishing Lake",
  "Fishing Pier",
  "Fishing Pond",
  "Fishing Store",
  "Fitness Center",
  "Fitness Equipment Wholesaler",
  "Fitted Furniture Supplier",
  "Fixed-Base Operator",
  "Flag Store",
  "Flamenco Dance Store",
  "Flamenco School",
  "Flavours Fragrances And Aroma Supplier",
  "Flea Market",
  "Flight School",
  "Floating Market",
  "Floor Refinishing Service",
  "Floor Sanding And Polishing Service",
  "Flooring",
  "Flooring Contractor",
  "Flooring Store",
  "Floridian Restaurant",
  "Florist",
  "Flour Mill",
  "Flower Delivery",
  "Flower Designer",
  "Flower Market",
  "Fmcg Goods Wholesaler",
  "Fmcg Manufacturer",
  "Foam Rubber Producer",
  "Foam Rubber Supplier",
  "Fondue Restaurant",
  "Food",
  "Food And Beverage Consultant",
  "Food And Beverage Exporter",
  "Food And Drink",
  "Food Bank",
  "Food Broker",
  "Food Court",
  "Food Delivery",
  "Food Machinery Supplier",
  "Food Manufacturer",
  "Food Manufacturing Supply",
  "Food Processing Company",
  "Food Processing Equipment",
  "Food Producer",
  "Food Production",
  "Food Products Supplier",
  "Food Seasoning Manufacturer",
  "Food Service",
  "Food Store",
  "Foot Bath",
  "Foot Care",
  "Foot Massage Parlor",
  "Football Club",
  "Football Field",
  "Footwear Wholesaler",
  "Ford Dealer",
  "Foreclosure Service",
  "Foreign Consulate",
  "Foreign Exchange Students Organization",
  "Foreign Languages Program School",
  "Foreign Trade Consultant",
  "Foreman Builders Association",
  "Forensic Consultant",
  "Forestry Office",
  "Forestry Service",
  "Forklift Dealer",
  "Forklift Rental Service",
  "Formal Wear Store",
  "Fortress",
  "Fortune Telling Services",
  "Foster Care Service",
  "Foundation",
  "Foundry",
  "Fountain",
  "Fountain Contractor",
  "Foursquare Church",
  "Franconian Restaurant",
  "Fraternal Organization",
  "Free Clinic",
  "Free Parking Lot",
  "Freestyle Wrestling",
  "Freight Forwarding Service",
  "French Language School",
  "French Restaurant",
  "French Steakhouse Restaurant",
  "Fresh Food Market",
  "Fried Chicken Takeaway",
  "Friends Church",
  "Frituur",
  "Frozen Dessert Supplier",
  "Frozen Food Manufacturer",
  "Frozen Food Store",
  "Frozen Yogurt Shop",
  "Fruit And Vegetable Processing",
  "Fruit And Vegetable Store",
  "Fruit And Vegetable Wholesaler",
  "Fruit Parlor",
  "Fruit Wholesaler",
  "Fruits Wholesaler",
  "Fuel Station",
  "Fuel Supplier",
  "Fugu Restaurant",
  "Fujian Restaurant",
  "Full Dress Rental Service",
  "Full Gospel Church",
  "Function Room Facility",
  "Fund Management Company",
  "Funeral Celebrant Service",
  "Funeral Director",
  "Funeral Home",
  "Fur Coat Shop",
  "Fur Manufacturer",
  "Fur Service",
  "Furnace Parts Supplier",
  "Furnace Repair Service",
  "Furnace Store",
  "Furnished Apartment Building",
  "Furniture",
  "Furniture Accessories",
  "Furniture Accessories Supplier",
  "Furniture Maker",
  "Furniture Manufacturer",
  "Furniture Rental Service",
  "Furniture Repair Shop",
  "Furniture Store",
  "Furniture Wholesaler",
  "Furrier",
  "Fusion Restaurant",
  "Futon Store",
  "Futsal Court",
  "Gambling House",
  "Gambling Instructor",
  "Game Store",
  "Garage Builder",
  "Garage Door Supplier",
  "Garbage Collection Service",
  "Garbage Dump",
  "Garbage Dump Service",
  "Garden",
  "Garden Building Supplier",
  "Garden Center",
  "Garden Furniture Shop",
  "Garden Machinery Supplier",
  "Gardener",
  "Gardening Products And Services",
  "Garment Exporter",
  "Gas And Automotive",
  "Gas Company",
  "Gas Cylinders Supplier",
  "Gas Engineer",
  "Gas Installation Service",
  "Gas Logs Supplier",
  "Gas Shop",
  "Gas Station",
  "Gasfitter",
  "Gasket Manufacturer",
  "Gastroenterologist",
  "Gastrointestinal Surgeon",
  "Gastropub",
  "Gated Community",
  "Gay & Lesbian Organization",
  "Gay Bar",
  "Gay Night Club",
  "Gay Sauna",
  "Gazebo Builder",
  "Gemologist",
  "Genealogist",
  "General Contractor",
  "General Education School",
  "General Hospital",
  "General Practice Attorney",
  "General Practitioner",
  "General Register Office",
  "General Store",
  "Generator Shop",
  "Genesis Dealer",
  "Geography And History Faculty",
  "Geological Research Company",
  "Geological Service",
  "Geologist",
  "Georgian Restaurant",
  "Geotechnical Engineer",
  "Geriatrician",
  "German Language School",
  "German Restaurant",
  "Geyser",
  "Ghost Town",
  "Gift Basket Store",
  "Gift Shop",
  "Gift Wrap Store",
  "Girl Bar",
  "Girls\' High School",
  "Glacier",
  "Glass & Mirror Shop",
  "Glass Block Supplier",
  "Glass Blower",
  "Glass Cutting Service",
  "Glass Engraver",
  "Glass Etching Service",
  "Glass Industry",
  "Glass Manufacturer",
  "Glass Merchant",
  "Glass Repair Service",
  "Glass Shop",
  "Glasses Repair Service",
  "Glassware Manufacturer",
  "Glassware Store",
  "Glassware Wholesaler",
  "Glazier",
  "Gluten-Free Restaurant",
  "Gmc Dealer",
  "Go-Kart Track",
  "Gold Dealer",
  "Gold Mining Company",
  "Goldfish Store",
  "Goldsmith",
  "Golf",
  "Golf Cart Dealer",
  "Golf Club",
  "Golf Course",
  "Golf Course Builder",
  "Golf Driving Range",
  "Golf Instructor",
  "Golf Shop",
  "Gondola Lift Station",
  "Gospel Church",
  "Gourmet Grocery Store",
  "Government",
  "Government College",
  "Government Economic Program",
  "Government Hospital",
  "Government Office",
  "Government School",
  "Gp",
  "Gps Supplier",
  "Graduate School",
  "Graffiti Removal Service",
  "Grain Elevator",
  "Grammar School",
  "Granite Supplier",
  "Graphic Designer",
  "Grassland",
  "Gravel Pit",
  "Gravel Plant",
  "Greco-Roman Wrestling",
  "Greek Orthodox Church",
  "Greek Restaurant",
  "Green Energy Supplier",
  "Greengrocer",
  "Greenhouse",
  "Greeting Card Shop",
  "Greyhound Stadium",
  "Grill",
  "Grill Store",
  "Grocery Delivery Service",
  "Grocery Store",
  "Ground Self Defense Force",
  "Group Accommodation",
  "Group Home",
  "Guatemalan Restaurant",
  "Guest House",
  "Guitar Instructor",
  "Guitar Store",
  "Gun Club",
  "Gun Shop",
  "Gurudwara",
  "Gutter Cleaning Service",
  "Gym",
  "Gymnasium School",
  "Gymnastics Center",
  "Gymnastics Club",
  "Gynecologist",
  "Gypsum Product Supplier",
  "Gyro Restaurant",
  "Haberdashery",
  "Hair",
  "Hair Care",
  "Hair Extension Technician",
  "Hair Extensions Supplier",
  "Hair Removal Service",
  "Hair Replacement Service",
  "Hair Salon",
  "Hair Transplantation Clinic",
  "Hairdresser",
  "Haitian Restaurant",
  "Hakka Restaurant",
  "Halal Restaurant",
  "Halfway House",
  "Hall",
  "Ham Shop",
  "Hamburger Restaurant",
  "Hammam",
  "Hand Surgeon",
  "Handbags Shop",
  "Handball Court",
  "Handicapped Transportation Service",
  "Handicraft",
  "Handicraft Exporter",
  "Handicraft Fair",
  "Handicraft Museum",
  "Handicraft School",
  "Handicrafts Wholesaler",
  "Handyman",
  "Handyman/Handywoman/Handyperson",
  "Hang Gliding Center",
  "Harbor",
  "Hardware Store",
  "Hardware Training Institute",
  "Harley-Davidson Dealer",
  "Hat Shop",
  "Haunted House",
  "Haute Couture Fashion House",
  "Haute French Restaurant",
  "Hawaiian Goods Store",
  "Hawaiian Restaurant",
  "Hawker Stall",
  "Hay Supplier",
  "Head Start Center",
  "Health",
  "Health And Beauty",
  "Health And Beauty Shop",
  "Health Care Facility",
  "Health Consultant",
  "Health Counselor",
  "Health Food Restaurant",
  "Health Food Store",
  "Health Insurance Agency",
  "Health Resort",
  "Health Spa",
  "Hearing Aid Repair Service",
  "Hearing Aid Store",
  "Heart Hospital",
  "Heating",
  "Heating Contractor",
  "Heating Equipment Supplier",
  "Heating Oil Supplier",
  "Height Works",
  "Helicopter Charter",
  "Helicopter Tour Agency",
  "Heliport",
  "Helium Gas Supplier",
  "Helpline",
  "Hematologist",
  "Hepatologist",
  "Herb Shop",
  "Herbal Medicine Store",
  "Herbalist",
  "Heritage Building",
  "Heritage Museum",
  "Heritage Preservation",
  "High Ropes Course",
  "High School",
  "Higher Education",
  "Higher Secondary School",
  "Highway Patrol",
  "Hiking Area",
  "Hindu Priest",
  "Hindu Temple",
  "Hip Hop Dance Class",
  "Hispanic Church",
  "Historic City Center",
  "Historical Landmark",
  "Historical Place",
  "Historical Place Museum",
  "Historical Society",
  "History Museum",
  "Hiv Testing Center",
  "Hoagie Restaurant",
  "Hobby Store",
  "Hockey",
  "Hockey Club",
  "Hockey Field",
  "Hockey Rink",
  "Hockey Supply Store",
  "Holding Company",
  "Holiday Accommodation Service",
  "Holiday Apartment",
  "Holiday Apartment Rental",
  "Holiday Home",
  "Holiday Park",
  "Holistic Medicine Practitioner",
  "Home And Construction",
  "Home Audio Store",
  "Home Automation Company",
  "Home Builder",
  "Home Cinema Installation",
  "Home Furnishings",
  "Home Goods Store",
  "Home Hairdresser",
  "Home Health Care Service",
  "Home Help",
  "Home Help Service Agency",
  "Home Improvement Store",
  "Home Inspector",
  "Home Insurance Agency",
  "Home Theater Store",
  "Homekill Service",
  "Homeless Service",
  "Homeless Shelter",
  "Homeopath",
  "Homeopathic Pharmacy",
  "Homeowners\' Association",
  "Homes",
  "Homestay",
  "Honda Dealer",
  "Honduran Restaurant",
  "Honey Farm",
  "Hong Kong Style Fast Food Restaurant",
  "Hookah Bar",
  "Hookah Store",
  "Horse Boarding Stable",
  "Horse Breeder",
  "Horse Carriage Station",
  "Horse Rental Service",
  "Horse Riding",
  "Horse Riding Field",
  "Horse Riding School",
  "Horse Trailer Dealer",
  "Horse Trainer",
  "Horse Transport Supplier",
  "Horseback Riding Service",
  "Horseshoe Smith",
  "Horsestable Studfarm",
  "Hose Supplier",
  "Hospice",
  "Hospital",
  "Hospital Department",
  "Hospital Equipment And Supplies",
  "Hospitality And Tourism School",
  "Hospitality High School",
  "Host Club",
  "Hostel",
  "Hot Bedstone Spa",
  "Hot Dog Restaurant",
  "Hot Dog Stand",
  "Hot Pot Restaurant",
  "Hot Spring",
  "Hot Spring Hotel",
  "Hot Tub Repair Service",
  "Hot Tub Store",
  "Hot Water System Supplier",
  "Hotel",
  "Hotel Management School",
  "Hotel Supply Store",
  "House Cleaning Service",
  "House Clearance Service",
  "House Sitter",
  "House Sitter Agency",
  "Houseboat Rental Service",
  "Household Chemicals Supplier",
  "Household Goods Wholesaler",
  "Housing",
  "Housing Association",
  "Housing Authority",
  "Housing Complex",
  "Housing Cooperative",
  "Housing Development",
  "Housing Society",
  "Housing Utility Company",
  "Hub Cap Supplier",
  "Human Resource Consulting",
  "Human Resources",
  "Hunan Restaurant",
  "Hungarian Restaurant",
  "Hunting And Fishing Store",
  "Hunting Area",
  "Hunting Club",
  "Hunting Preserve",
  "Hunting Store",
  "Hvac Contractor",
  "Hydraulic Engineer",
  "Hydraulic Equipment Supplier",
  "Hydraulic Repair Service",
  "Hydroelectric Power Plant",
  "Hydroponics Equipment Supplier",
  "Hygiene Articles Wholesaler",
  "Hygiene Station",
  "Hyperbaric Medicine Physician",
  "Hypermarket",
  "Hypnotherapy Service",
  "Hyundai Dealer",
  "Ice",
  "Ice Cream Equipment Supplier",
  "Ice Cream Shop",
  "Ice Hockey Club",
  "Ice Skating Club",
  "Ice Skating Instructor",
  "Ice Skating Rink",
  "Ice Supplier",
  "Idol Manufacturer",
  "Image Consultant",
  "Imax Theater",
  "Immigration & Naturalization Service",
  "Immigration Attorney",
  "Immigration Detention Centre",
  "Immunologist",
  "Import Export Company",
  "Importer",
  "Incense Supplier",
  "Incineration Plant",
  "Inclined Railway Station",
  "Income Protection Insurance",
  "Income Protection Insurance Agency",
  "Income Tax Help Association",
  "Indian Grocery Store",
  "Indian Muslim Restaurant",
  "Indian Restaurant",
  "Indian Sweets Shop",
  "Indian Takeaway",
  "Indonesian Restaurant",
  "Indoor Cycling",
  "Indoor Golf Course",
  "Indoor Lodging",
  "Indoor Playground",
  "Indoor Swimming Pool",
  "Industrial Area",
  "Industrial Building",
  "Industrial Chemicals Wholesaler",
  "Industrial Consultant",
  "Industrial Design Company",
  "Industrial Door Supplier",
  "Industrial Engineer",
  "Industrial Engineers Association",
  "Industrial Equipment Supplier",
  "Industrial Framework Supplier",
  "Industrial Gas Supplier",
  "Industrial Real Estate Agency",
  "Industrial Supermarket",
  "Industrial Technical Engineers Association",
  "Industrial Vacuum Equipment Supplier",
  "Industry",
  "Infectious Disease Physician",
  "Infiniti Dealer",
  "Information Bureau",
  "Information Centers",
  "Information Services",
  "Inlet",
  "Inn",
  "Institute",
  "Institute Of Technology",
  "Instruction",
  "Instrumentation Engineer",
  "Insulation Contractor",
  "Insulation Materials Store",
  "Insulator Supplier",
  "Insurance",
  "Insurance Agency",
  "Insurance Attorney",
  "Insurance Broker",
  "Insurance Company",
  "Insurance School",
  "Intellectual Property Registry",
  "Intensivist",
  "Interior Architect Office",
  "Interior Construction Contractor",
  "Interior Decoration",
  "Interior Decorator",
  "Interior Designer",
  "Interior Door",
  "Interior Door Shop",
  "Interior Fitting Contractor",
  "Interior Plant Service",
  "Internal Medicine Ward",
  "International Airport",
  "International School",
  "International Trade Consultant",
  "Internet",
  "Internet Cafe",
  "Internet Marketing Service",
  "Internet Service Provider",
  "Internet Shop",
  "Internist",
  "Intersection",
  "Investment Bank",
  "Investment Company",
  "Investment Service",
  "Invitation Printing Service",
  "Irish Goods Store",
  "Irish Pub",
  "Irish Restaurant",
  "Iron Steel Contractor",
  "Iron Ware Dealer",
  "Iron Works",
  "Irrigation Equipment Supplier",
  "Island",
  "Israeli Restaurant",
  "Isuzu Dealer",
  "Italian Grocery Store",
  "Italian Restaurant",
  "Iup",
  "Izakaya Restaurant",
  "Jaguar Dealer",
  "Jain Temple",
  "Jamaican Restaurant",
  "Janitorial Equipment Supplier",
  "Janitorial Service",
  "Japanese Confectionery Shop",
  "Japanese Curry Restaurant",
  "Japanese Delicatessen",
  "Japanese Grocery Store",
  "Japanese Language Instructor",
  "Japanese Prefecture Government Office",
  "Japanese Regional Restaurant",
  "Japanese Restaurant",
  "Japanese Steakhouse",
  "Japanese Sweets Restaurant",
  "Japanized Western Restaurant",
  "Jazz Club",
  "Jeans Shop",
  "Jeep Dealer",
  "Jehovah\'S Witness Kingdom Hall",
  "Jeweler",
  "Jewellery Manufacturer",
  "Jewelry Appraiser",
  "Jewelry Buyer",
  "Jewelry Designer",
  "Jewelry Engraver",
  "Jewelry Equipment Supplier",
  "Jewelry Exporter",
  "Jewelry Manufacturer",
  "Jewelry Repair Service",
  "Jewelry Store",
  "Jewish Restaurant",
  "Joiner",
  "Judicial Scrivener",
  "Judo Club",
  "Judo School",
  "Juice Shop",
  "Jujitsu School",
  "Junior College",
  "Junk Dealer",
  "Junk Store",
  "Junkyard",
  "Justice Department",
  "Justice Of The Peace",
  "Jute Mill",
  "Juvenile Court",
  "Juvenile Detention Center",
  "Kabaddi Club",
  "Karaoke",
  "Karaoke Bar",
  "Karaoke Equipment Rental Service",
  "Karate Club",
  "Karate School",
  "Karma Dealer",
  "Kawasaki Motorcycle Dealer",
  "Kebab Shop",
  "Kennel",
  "Kerosene Supplier",
  "Key Duplication Service",
  "Kia Dealer",
  "Kickboxing School",
  "Kilt Shop And Hire",
  "Kimono Store",
  "Kindergarten",
  "Kinesiologist",
  "Kiosk",
  "Kitchen",
  "Kitchen Furniture Store",
  "Kitchen Remodeler",
  "Kitchen Supply Store",
  "Kite Shop",
  "Knife Manufacturing",
  "Knife Store",
  "Knit Shop",
  "Knitting Instructor",
  "Knitwear Manufacturer",
  "Korean Barbecue Restaurant",
  "Korean Beef Restaurant",
  "Korean Church",
  "Korean Grocery Store",
  "Korean Restaurant",
  "Kosher Grocery Store",
  "Kosher Restaurant",
  "Kung Fu School",
  "Kyoto Style Japanese Restaurant",
  "Labor Relations Attorney",
  "Labor Union",
  "Laboratory",
  "Laboratory Equipment Supplier",
  "Labour Club",
  "Ladder Supplier",
  "Lagoon",
  "Lake",
  "Lamborghini Dealer",
  "Laminating Equipment Supplier",
  "Lamination Service",
  "Lamp Repair Service",
  "Lamp Shade Supplier",
  "Land Allotment",
  "Land Mass",
  "Land Planning Authority",
  "Land Reform Institute",
  "Land Registry Office",
  "Land Rover Dealer",
  "Land Surveying Office",
  "Land Surveyor",
  "Landmark",
  "Landscape Architect",
  "Landscape Designer",
  "Landscape Lighting Designer",
  "Landscaper",
  "Landscaping Supply Store",
  "Language School",
  "Laotian Restaurant",
  "Lapidary",
  "Laser Cutting Service",
  "Laser Equipment Supplier",
  "Laser Hair Removal Service",
  "Laser Tag Center",
  "Lasik Surgeon",
  "Latin American Restaurant",
  "Laundromat",
  "Laundry",
  "Laundry Service",
  "Lava Field",
  "Law Book Store",
  "Law Firm",
  "Law Library",
  "Law School",
  "Lawn Bowls Club",
  "Lawn Care Service",
  "Lawn Equipment Rental Service",
  "Lawn Irrigation Equipment Supplier",
  "Lawn Mower Repair Service",
  "Lawn Mower Store",
  "Lawn Sprinkler System Contractor",
  "Lawyer",
  "Lawyers Association",
  "Leagues Club",
  "Learner Driver Training Area",
  "Learning Center",
  "Leasing Service",
  "Leather Cleaning Service",
  "Leather Coats Store",
  "Leather Exporter",
  "Leather Goods Manufacturer",
  "Leather Goods Store",
  "Leather Goods Supplier",
  "Leather Goods Wholesaler",
  "Leather Repair Service",
  "Leather Wholesaler",
  "Lebanese Restaurant",
  "Legal Affairs Bureau",
  "Legal Aid Office",
  "Legal Services",
  "Legally Defined Lodging",
  "Leisure Centre",
  "Lexus Dealer",
  "Library",
  "License Bureau",
  "License Plate Frames Supplier",
  "Lido",
  "Life Coach",
  "Life Insurance Agency",
  "Light Bulb Supplier",
  "Light Rail Station",
  "Lighthouse",
  "Lighting",
  "Lighting Consultant",
  "Lighting Contractor",
  "Lighting Manufacturer",
  "Lighting Store",
  "Lighting Wholesaler",
  "Limousine Service",
  "Lincoln Dealer",
  "Line Marking Service",
  "Linens Store",
  "Lingerie Manufacturer",
  "Lingerie Store",
  "Lingerie Wholesaler",
  "Linoleum Store",
  "Liquidator",
  "Liquor Store",
  "Liquor Wholesaler",
  "Literacy Program",
  "Lithuanian Restaurant",
  "Little League Club",
  "Little League Field",
  "Live Music Bar",
  "Live Music Venue",
  "Livery Company",
  "Livestock",
  "Livestock Auction House",
  "Livestock Breeder",
  "Livestock Dealer",
  "Livestock Farming Service",
  "Livestock Producer",
  "Loan Agency",
  "Local Government Office",
  "Local History Museum",
  "Local Medical Services",
  "Locks Supplier",
  "Locksmith",
  "Lodge",
  "Lodging",
  "Log Cabins",
  "Log Home Builder",
  "Logging Contractor",
  "Logistics",
  "Logistics Service",
  "Loss Adjuster",
  "Lost Property Office",
  "Lottery Retailer",
  "Lottery Shop",
  "Lounge",
  "Love Hotel",
  "Low Emission Zone",
  "Low Income Housing Program",
  "Lpg Conversion",
  "Luggage Repair Service",
  "Luggage Storage Facility",
  "Luggage Store",
  "Luggage Wholesaler",
  "Lumber Store",
  "Lunch Restaurant",
  "Lutheran Church",
  "Lymph Drainage Therapist",
  "Machine Construction",
  "Machine Knife Supplier",
  "Machine Maintenance",
  "Machine Repair Service",
  "Machine Shop",
  "Machine Workshop",
  "Machinery Parts Manufacturer",
  "Machining Manufacturer",
  "Magazine Store",
  "Magic Store",
  "Magician",
  "Magistrates\' Court",
  "Mahjong House",
  "Mail Room",
  "Mailbox Rental Service",
  "Mailbox Supplier",
  "Mailing Machine Supplier",
  "Mailing Service",
  "Main Customs Office",
  "Make-Up Artist",
  "Makerspace",
  "Malaysian Restaurant",
  "Mammography Service",
  "Management School",
  "Mandarin Restaurant",
  "Manor House",
  "Manufactured Home Transporter",
  "Manufacturer",
  "Map Store",
  "Mapping Service",
  "Marble Contractor",
  "Marble Supplier",
  "Marina",
  "Marine Engineer",
  "Marine Protected Area",
  "Marine Self Defense Force",
  "Marine Supply Store",
  "Marine Surveyor",
  "Marines Facility",
  "Maritime Museum",
  "Market",
  "Market Operator",
  "Market Researcher",
  "Marketing",
  "Marketing Agency",
  "Marketing Consultant",
  "Markmens Clubhouse",
  "Marriage Celebrant",
  "Marriage License Bureau",
  "Marriage Or Relationship Counselor",
  "Martial Arts",
  "Martial Arts Club",
  "Martial Arts School",
  "Martial Arts Supply Store",
  "Maserati Dealer",
  "Masonic Center",
  "Masonry Contractor",
  "Masonry Supply Store",
  "Massage",
  "Massage Parlor",
  "Massage School",
  "Massage Spa",
  "Massage Supply Store",
  "Massage Therapist",
  "Match Box Manufacturer",
  "Material Handling Equipment Supplier",
  "Maternity Hospital",
  "Maternity Store",
  "Mathematics School",
  "Mattress Store",
  "Mausoleum Builder",
  "Mazda Dealer",
  "Mclaren Dealer",
  "Meal Delivery",
  "Measuring Instruments Supplier",
  "Meat Dish Restaurant",
  "Meat Packer",
  "Meat Processor",
  "Meat Products",
  "Meat Products Store",
  "Meat Wholesaler",
  "Mechanic",
  "Mechanical Contractor",
  "Mechanical Engineer",
  "Mechanical Plant",
  "Media And Information Sciences Faculty",
  "Media Company",
  "Media Consultant",
  "Media House",
  "Mediation Service",
  "Medical Billing Service",
  "Medical Book Store",
  "Medical Center",
  "Medical Certificate Service",
  "Medical Clinic",
  "Medical Diagnostic Imaging Center",
  "Medical Equipment Manufacturer",
  "Medical Equipment Supplier",
  "Medical Examiner",
  "Medical Group",
  "Medical Laboratory",
  "Medical Lawyer",
  "Medical Office",
  "Medical School",
  "Medical Spa",
  "Medical Specialist",
  "Medical Supply Store",
  "Medical Technology Manufacturer",
  "Medical Transcription Service",
  "Medicine Exporter",
  "Meditation Center",
  "Meditation Instructor",
  "Mediterranean Restaurant",
  "Meeting Planning Service",
  "Meeting Room",
  "Mehndi Designer",
  "Memorial",
  "Memorial Estate",
  "Memorial Park",
  "Men\'S Clothing Store",
  "Men\'S Health Physician",
  "Mennonite Church",
  "Mens Tailor",
  "Mental Health",
  "Mental Health Clinic",
  "Mental Health Service",
  "Mental Hospital",
  "Mercantile Development",
  "Mercedes-Benz Dealer",
  "Messianic Synagogue",
  "Metal Construction Company",
  "Metal Detecting Equipment Supplier",
  "Metal Fabricator",
  "Metal Finisher",
  "Metal Heat Treating Service",
  "Metal Industry Suppliers",
  "Metal Machinery Supplier",
  "Metal Polishing Service",
  "Metal Processing Company",
  "Metal Stamping Service",
  "Metal Supplier",
  "Metal Working Shop",
  "Metal Workshop",
  "Metallurgy Company",
  "Metalware Dealer",
  "Metalware Producer",
  "Metaphysical Supply Store",
  "Methodist Church",
  "Metropolitan Train Company",
  "Mexican Goods Store",
  "Mexican Grocery Store",
  "Mexican Restaurant",
  "Mexican Torta Restaurant",
  "Mfr",
  "Microbiologist",
  "Microwave Oven Repair Service",
  "Mid-Atlantic Restaurant (Us)",
  "Middle Eastern Restaurant",
  "Middle School",
  "Midwife",
  "Military",
  "Military Airport",
  "Military Archive",
  "Military Barracks",
  "Military Base",
  "Military Board",
  "Military Cemetery",
  "Military Hospital",
  "Military Recruiting Office",
  "Military Residence",
  "Military School",
  "Military Town",
  "Milk Delivery Service",
  "Mill",
  "Millwork Shop",
  "Mine",
  "Mineral Water Company",
  "Mini Dealer",
  "Miniature Golf Course",
  "Miniatures Store",
  "Minibus Taxi Service",
  "Mining Company",
  "Mining Consultant",
  "Mining Engineer",
  "Mining Equipment",
  "Ministry Of Education",
  "Mirror Shop",
  "Missing Persons Organization",
  "Mission",
  "Mitsubishi Dealer",
  "Mobile Caterer",
  "Mobile Disco",
  "Mobile Hairdresser",
  "Mobile Home Dealer",
  "Mobile Home Park",
  "Mobile Home Rental Agency",
  "Mobile Home Supply Store",
  "Mobile Money Agent",
  "Mobile Network Operator",
  "Mobile Phone Repair Shop",
  "Mobility Equipment Supplier",
  "Model Car Play Area",
  "Model Design Company",
  "Model Portfolio Studio",
  "Model Shop",
  "Model Train Store",
  "Modeling Agency",
  "Modeling School",
  "Modern Art Museum",
  "Modern British Restaurant",
  "Modern European Restaurant",
  "Modern French Restaurant",
  "Modern Indian Restaurant",
  "Modern Izakaya Restaurant",
  "Modular Home Builder",
  "Modular Home Dealer",
  "Mold Maker",
  "Molding Supplier",
  "Monastery",
  "Money Order Service",
  "Money Transfer Service",
  "Mongolian Barbecue Restaurant",
  "Monogramming Service",
  "Monorail Station",
  "Montessori School",
  "Monument",
  "Monument Maker",
  "Moped Dealer",
  "Moravian Church",
  "Moroccan Restaurant",
  "Mortgage Broker",
  "Mortgage Lender",
  "Mortuary",
  "Mosque",
  "Motel",
  "Motor Scooter Dealer",
  "Motor Scooter Repair Shop",
  "Motor Vehicle Dealer",
  "Motorcycle Club",
  "Motorcycle Dealer",
  "Motorcycle Driving School",
  "Motorcycle Insurance Agency",
  "Motorcycle Parts Store",
  "Motorcycle Rental Agency",
  "Motorcycle Repair Shop",
  "Motorcycle Shop",
  "Motorcycles",
  "Motoring Club",
  "Motorsports Store",
  "Mountain Cabin",
  "Mountain Cable Car",
  "Mountain Pass",
  "Mountain Peak",
  "Mountain Range",
  "Mountaineering Class",
  "Mover",
  "Movie Rental",
  "Movie Rental Kiosk",
  "Movie Rental Store",
  "Movie Studio",
  "Movie Theater",
  "Moving And Storage Service",
  "Moving Company",
  "Moving Supply Store",
  "Mri Center",
  "Muay Thai Boxing Gym",
  "Muffler Shop",
  "Mulch Supplier",
  "Multi-Unit Residential Building",
  "Multimedia And Electronic Book Publisher",
  "Municipal Administration Office",
  "Municipal Corporation",
  "Municipal Department Agricultural Development",
  "Municipal Department Civil Defense",
  "Municipal Department Communication",
  "Municipal Department Finance",
  "Municipal Department Housing And Urban Development",
  "Municipal Department Of Agriculture Food Supply",
  "Municipal Department Of Culture",
  "Municipal Department Of Sports",
  "Municipal Department Of Tourism",
  "Municipal Department Science Technology",
  "Municipal Hall",
  "Municipal Health Department",
  "Municipal Office Education",
  "Municipal Social Development",
  "Museum",
  "Museum Of Space History",
  "Museum Of Zoology",
  "Music",
  "Music Box Store",
  "Music College",
  "Music Conservatory",
  "Music Instruction",
  "Music Instructor",
  "Music Management And Promotion",
  "Music Producer",
  "Music Publisher",
  "Music School",
  "Music Store",
  "Musical Club",
  "Musical Instrument Manufacturer",
  "Musical Instrument Rental Service",
  "Musical Instrument Repair Shop",
  "Musical Instrument Store",
  "Musician",
  "Musician And Composer",
  "Nail Salon",
  "Nanotechnology Engineer",
  "National Forest",
  "National Health Foundation",
  "National Library",
  "National Museum",
  "National Park",
  "National Reserve",
  "Native American Goods Store",
  "Native American Restaurant",
  "Natural Feature",
  "Natural Goods Store",
  "Natural History Museum",
  "Natural Rock Climbing Area",
  "Natural Stone Exporter",
  "Natural Stone Supplier",
  "Natural Stone Wholesaler",
  "Nature Preserve",
  "Naturopathic Practitioner",
  "Naval Base",
  "Neapolitan Restaurant",
  "Needlework Shop",
  "Neon Sign Shop",
  "Neonatal Physician",
  "Nepalese Restaurant",
  "Nephrologist",
  "Netball Club",
  "Neurologist",
  "Neurophysiologist",
  "Neuropsychologist",
  "Neurosurgeon",
  "New Age Church",
  "New American Restaurant",
  "New England Restaurant",
  "New Years Tree Market",
  "New Zealand Restaurant",
  "News Service",
  "Newspaper Advertising Department",
  "Newspaper Distribution",
  "Newspaper Publisher",
  "Newsstand",
  "Nicaraguan Restaurant",
  "Night Club",
  "Night Market",
  "Nightlife",
  "Nissan Dealer",
  "Non Smoking Holiday Home",
  "Non-Denominational Church",
  "Non-Governmental Organization",
  "Non-Profit Organisation",
  "Non-Profit Organization",
  "Noodle Shop",
  "North African Restaurant",
  "North Eastern Indian Restaurant",
  "North Indian Restaurant",
  "Northern Italian Restaurant",
  "Norwegian Restaurant",
  "Notable Street",
  "Notaries Association",
  "Notary Public",
  "Notions Store",
  "Novelties Wholesaler",
  "Novelty Store",
  "Nuclear Engineer",
  "Nuclear Power Company",
  "Nuclear Power Plant",
  "Nudist Club",
  "Nudist Park",
  "Nuevo Latino Restaurant",
  "Number Of Appearances",
  "Numerologist",
  "Nurse Practitioner",
  "Nursery",
  "Nursery School",
  "Nursing Agency",
  "Nursing Association",
  "Nursing Home",
  "Nursing Room",
  "Nursing School",
  "Nut Store",
  "Nutritionist",
  "Oaxacan Restaurant",
  "Observation Deck",
  "Observatory",
  "Obstetrician-Gynecologist",
  "Occupational Health Service",
  "Occupational Medical Physician",
  "Occupational Safety And Health",
  "Occupational Therapist",
  "Off Roading Area",
  "Off Track Betting Shop",
  "Off-Road Race Track",
  "Office",
  "Office Accessories Wholesaler",
  "Office Equipment Rental Service",
  "Office Equipment Repair Service",
  "Office Equipment Supplier",
  "Office Furniture Store",
  "Office Of A Fair Trade Organization",
  "Office Of Vital Records",
  "Office Refurbishment Service",
  "Office Services",
  "Office Space Rental Agency",
  "Office Supply",
  "Office Supply Store",
  "Office Supply Wholesaler",
  "Oil & Natural Gas Company",
  "Oil And Gas Exploration Service",
  "Oil Change Service",
  "Oil Field Equipment Supplier",
  "Oil Refinery",
  "Oil Store",
  "Oil Wholesaler",
  "Oilfield",
  "Oldsmobile Dealer",
  "Olive Oil Bottling Company",
  "Olive Oil Cooperative",
  "Olive Oil Manufacturer",
  "Oncologist",
  "Open Air Museum",
  "Open University",
  "Opera Company",
  "Opera House",
  "Ophthalmologist",
  "Ophthalmology Clinic",
  "Optical Products Manufacturer",
  "Optical Wholesaler",
  "Optician",
  "Optometrist",
  "Oral And Maxillofacial Surgeon",
  "Oral Surgeon",
  "Orchard",
  "Orchestra",
  "Orchid Farm",
  "Orchid Grower",
  "Organ Donation And Tissue Bank",
  "Organic Drug Store",
  "Organic Farm",
  "Organic Food Store",
  "Organic Restaurant",
  "Organic Shop",
  "Oriental Goods Store",
  "Oriental Medical Clinic",
  "Oriental Medicine Clinic",
  "Oriental Medicine Store",
  "Oriental Rug Store",
  "Orphan Asylum",
  "Orphanage",
  "Orthodontist",
  "Orthodox Church",
  "Orthodox Synagogue",
  "Orthopedic Clinic",
  "Orthopedic Shoe Store",
  "Orthopedic Surgeon",
  "Orthoptist",
  "Orthotics & Prosthetics Service",
  "Osteopath",
  "Otolaryngologist",
  "Otolaryngology Clinic",
  "Outboard Motor Store",
  "Outdoor Activity Organiser",
  "Outdoor Bath",
  "Outdoor Clothing And Equipment Shop",
  "Outdoor Equestrian Facility",
  "Outdoor Furniture Store",
  "Outdoor Movie Theater",
  "Outdoor Sports Store",
  "Outdoor Swimming Pool",
  "Outerwear Store",
  "Outlet Mall",
  "Outlet Store",
  "Oxygen Cocktail Spot",
  "Oxygen Equipment Supplier",
  "Oyster Bar Restaurant",
  "Oyster Supplier",
  "Pachinko Parlor",
  "Pacific Northwest Restaurant (Us)",
  "Pacific Rim Restaurant",
  "Package Locker",
  "Packaging Company",
  "Packaging Machinery",
  "Packaging Supply Store",
  "Padel Club",
  "Padel Court",
  "Pagoda",
  "Pain Control Clinic",
  "Pain Management Physician",
  "Paint Manufacturer",
  "Paint Store",
  "Paint Stripping Company",
  "Paint Stripping Service",
  "Paintball Center",
  "Paintball Store",
  "Painter",
  "Painting",
  "Painting Lessons",
  "Painting Studio",
  "Paintings Store",
  "Pakistani Restaurant",
  "Pallet Supplier",
  "Pan-Asian Restaurant",
  "Pan-Latin Restaurant",
  "Pancake Restaurant",
  "Pantry",
  "Paper Bag Supplier",
  "Paper Distributor",
  "Paper Exporter",
  "Paper Mill",
  "Paper Shredding Machine Supplier",
  "Paper Store",
  "Paralegal Services Provider",
  "Parapharmacy",
  "Parasailing Ride Service",
  "Parish",
  "Park",
  "Park & Ride",
  "Parking",
  "Parking Garage",
  "Parking Lot",
  "Parking Lot For Bicycles",
  "Parking Lot For Motorcycles",
  "Parkour Spot",
  "Parochial School",
  "Parsi Temple",
  "Part Time Daycare",
  "Party",
  "Party Equipment Rental Service",
  "Party Planner",
  "Party Store",
  "Passport Agent",
  "Passport Office",
  "Passport Photo Processor",
  "Pasta Shop",
  "Pastry Shop",
  "Patent Attorney",
  "Patent Office",
  "Paternity Testing Service",
  "Pathologist",
  "Patients Support Association",
  "Patio Enclosure Supplier",
  "Patisserie",
  "Paving Contractor",
  "Paving Materials Supplier",
  "Pawn Shop",
  "Payphone",
  "Payroll Service",
  "Pedestrian Zone",
  "Pediatric Cardiologist",
  "Pediatric Clinic",
  "Pediatric Dentist",
  "Pediatric Dermatologist",
  "Pediatric Endocrinologist",
  "Pediatric Gastroenterologist",
  "Pediatric Hematologist",
  "Pediatric Nephrologist",
  "Pediatric Neurologist",
  "Pediatric Oncologist",
  "Pediatric Ophthalmologist",
  "Pediatric Orthopedic Surgeon",
  "Pediatric Pulmonologist",
  "Pediatric Rheumatologist",
  "Pediatric Surgeon",
  "Pediatric Urologist",
  "Pediatrician",
  "Pen Store",
  "Peninsula",
  "Pennsylvania Dutch Restaurant",
  "Pension Office",
  "Pentecostal Church",
  "Performing Arts",
  "Performing Arts Group",
  "Performing Arts Theater",
  "Perfume Store",
  "Perinatal Center",
  "Periodontist",
  "Permanent Make-Up Clinic",
  "Persian Restaurant",
  "Personal Chef Service",
  "Personal Injury Attorney",
  "Personal Repair Service",
  "Personal Trainer",
  "Personal Watercraft Dealer",
  "Peruvian Restaurant",
  "Pest Control Service",
  "Pet Adoption Service",
  "Pet Boarding Service",
  "Pet Care",
  "Pet Care Service",
  "Pet Cemetery",
  "Pet Friendly Accommodation",
  "Pet Funeral Service",
  "Pet Groomer",
  "Pet Moving Service",
  "Pet Sitter",
  "Pet Store",
  "Pet Supply Store",
  "Pet Trainer",
  "Petrochemical Engineer",
  "Petroleum Products Company",
  "Pets",
  "Pharmaceutical Company",
  "Pharmaceutical Lab",
  "Pharmaceutical Products Wholesaler",
  "Pharmacy",
  "Pho Restaurant",
  "Phone Repair Service",
  "Photo Agency",
  "Photo Booth",
  "Photo Lab",
  "Photo Restoration Service",
  "Photo Shop",
  "Photocopiers Supplier",
  "Photographer",
  "Photography",
  "Photography Class",
  "Photography School",
  "Photography Service",
  "Photography Studio",
  "Physiatrist",
  "Physical Examination Center",
  "Physical Fitness Program",
  "Physical Therapist",
  "Physical Therapy Clinic",
  "Physician",
  "Physician Assistant",
  "Physician Referral Service",
  "Physiotherapy Equipment Supplier",
  "Piano Bar",
  "Piano Instructor",
  "Piano Maker",
  "Piano Moving Service",
  "Piano Repair Service",
  "Piano Store",
  "Piano Tuning Service",
  "Pick Your Own Farm Produce",
  "Pickleball Court",
  "Picnic Ground",
  "Picture Frame Shop",
  "Pie Shop",
  "Pier",
  "Pig Farm",
  "Pilates Studio",
  "Pile Driving Service",
  "Pilgrimage Place",
  "Pinball Machine Supplier",
  "Pine Furniture Shop",
  "Pipe Supplier",
  "Pizza Delivery",
  "Pizza Restaurant",
  "Pizza Takeaway",
  "Pizza Takeout",
  "Piñatas Supplier",
  "Place Of Worship",
  "Planetarium",
  "Plant And Machinery Hire",
  "Plant Nursery",
  "Plasterer",
  "Plastic Bag Supplier",
  "Plastic Bags Wholesaler",
  "Plastic Fabrication Company",
  "Plastic Injection Molding Service",
  "Plastic Products Supplier",
  "Plastic Resin Manufacturer",
  "Plastic Surgeon",
  "Plastic Surgery Clinic",
  "Plastic Wholesaler",
  "Plateau",
  "Plating Service",
  "Play School",
  "Playground",
  "Playground Equipment Supplier",
  "Playgroup",
  "Plaza",
  "Plumber",
  "Plumbing Supply Store",
  "Plus Size Clothing Store",
  "Plywood Supplier",
  "Pneumatic Tools Supplier",
  "Podiatrist",
  "Poke Bar",
  "Police",
  "Police Academy",
  "Police Department",
  "Police Station",
  "Police Supply Store",
  "Polish Restaurant",
  "Political Party",
  "Political Party Office",
  "Polo Club",
  "Polygraph Service",
  "Polymer Supplier",
  "Polynesian Restaurant",
  "Polytechnic College",
  "Polythene And Plastic Sheeting Supplier",
  "Pond",
  "Pond Contractor",
  "Pond Fish Supplier",
  "Pond Supply Store",
  "Pony Club",
  "Pony Ride Service",
  "Pool Academy",
  "Pool Billard Club",
  "Pool Cleaning Service",
  "Pool Hall",
  "Popcorn Store",
  "Porsche Dealer",
  "Port",
  "Port Authority",
  "Port Operating Company",
  "Portable Building Manufacturer",
  "Portable Toilet Supplier",
  "Portrait Studio",
  "Portuguese Restaurant",
  "Post Office",
  "Postal Code",
  "Poster Store",
  "Pottery",
  "Pottery Classes",
  "Pottery Manufacturer",
  "Pottery Store",
  "Poultry Farm",
  "Poultry Store",
  "Powder Coating Service",
  "Power Plant Consultant",
  "Power Plant Equipment Supplier",
  "Power Station",
  "Powersports Vehicle Dealer",
  "Po’ Boys Restaurant",
  "Prawn Fishing",
  "Pre Gymnasium School",
  "Precision Engineer",
  "Prefabricated House Companies",
  "Pregnancy Care Center",
  "Preparatory School",
  "Presbyterian Church",
  "Preschool",
  "Press Advisory",
  "Pressure Washing Service",
  "Pretzel Store",
  "Priest",
  "Primary School",
  "Print Shop",
  "Printed Music Publisher",
  "Printer Ink Refill Store",
  "Printer Repair Service",
  "Printing",
  "Printing Equipment And Supplies",
  "Printing Equipment Supplier",
  "Prison",
  "Private College",
  "Private Educational Institution",
  "Private Equity Firm",
  "Private Golf Course",
  "Private Hospital",
  "Private Investigator",
  "Private School",
  "Private Sector Bank",
  "Private Tutor",
  "Private University",
  "Probation Office",
  "Process Server",
  "Proctologist",
  "Produce Market",
  "Produce Wholesaler",
  "Professional And Hobby Associations",
  "Professional Organizer",
  "Professional Services",
  "Promenade",
  "Promotional Products Supplier",
  "Propane Supplier",
  "Propeller Shop",
  "Property Administrator",
  "Property Investment",
  "Property Maintenance",
  "Property Management Company",
  "Prosthetics",
  "Prosthodontist",
  "Protective Clothing Supplier",
  "Protestant Church",
  "Provincial Council",
  "Psychiatric Hospital",
  "Psychiatrist",
  "Psychic",
  "Psychoanalyst",
  "Psychologist",
  "Psychoneurological Specialized Clinic",
  "Psychopedagogy Clinic",
  "Psychosomatic Medical Practitioner",
  "Psychotherapist",
  "Pub",
  "Public Amenity House",
  "Public Bath",
  "Public Bathroom",
  "Public Beach",
  "Public Call Office Booth",
  "Public Defender\'S Office",
  "Public Educational Institution",
  "Public Female Bathroom",
  "Public Golf Course",
  "Public Health Department",
  "Public Housing",
  "Public Library",
  "Public Male Bathroom",
  "Public Medical Center",
  "Public Parking Lot",
  "Public Parking Space",
  "Public Prosecutors Office",
  "Public Relations Firm",
  "Public Safety Office",
  "Public School",
  "Public Sector Bank",
  "Public Services",
  "Public Swimming Pool",
  "Public Transport",
  "Public University",
  "Public Utility",
  "Public Webcam",
  "Public Wheelchair-Accessible Bathroom",
  "Public Works Department",
  "Publisher",
  "Puerto Rican Restaurant",
  "Pulmonologist",
  "Pump Supplier",
  "Pumping Equipment And Service",
  "Pumpkin Patch",
  "Punjabi Restaurant",
  "Puppet Theater",
  "Pvc Industry",
  "Pvc Windows Supplier",
  "Pyrotechnician",
  "Quaker Church",
  "Quantity Surveyor",
  "Quarry",
  "Quilt Shop",
  "Race Car Dealer",
  "Racecourse",
  "Racing Car Parts Store",
  "Rack",
  "Raclette Restaurant",
  "Racquetball Club",
  "Radiator Repair Service",
  "Radiator Shop",
  "Radio Broadcaster",
  "Radiologist",
  "Radiotherapist",
  "Raft Trip Outfitter",
  "Rafting",
  "Rail Museum",
  "Railing Contractor",
  "Railroad Company",
  "Railroad Contractor",
  "Railroad Equipment Supplier",
  "Railroad Ties Supplier",
  "Railway Services",
  "Rainwater Tank Supplier",
  "Ram Dealer",
  "Ramen Restaurant",
  "Ranch",
  "Rapids",
  "Rare Book Store",
  "Ravine",
  "Raw Food Restaurant",
  "Ready Mix Concrete Supplier",
  "Real Estate",
  "Real Estate Agency",
  "Real Estate Agent",
  "Real Estate Agents",
  "Real Estate Appraiser",
  "Real Estate Attorney",
  "Real Estate Auctioneer",
  "Real Estate Consultant",
  "Real Estate Developer",
  "Real Estate Fair",
  "Real Estate Rental",
  "Real Estate Rental Agency",
  "Real Estate School",
  "Real Estate Surveyor",
  "Reclamation Centre",
  "Record Company",
  "Record Store",
  "Recording Studio",
  "Records Storage Facility",
  "Recreation",
  "Recreation Center",
  "Recreational Vehicle Rental Agency",
  "Recruiter",
  "Rectory",
  "Recycling",
  "Recycling Center",
  "Recycling Container Location",
  "Recycling Drop-Off Location",
  "Reef",
  "Reenactment Site",
  "Reflexologist",
  "Reform Synagogue",
  "Reformed Church",
  "Refrigerated Transport Service",
  "Refrigerator Repair Service",
  "Refrigerator Store",
  "Refugee Camp",
  "Regional Airport",
  "Regional Council",
  "Regional Government Office",
  "Registered General Nurse",
  "Registration Office",
  "Registry Office",
  "Rehabilitation Center",
  "Rehearsal Studio",
  "Reiki Therapist",
  "Religious Book Store",
  "Religious Destination",
  "Religious Goods Store",
  "Religious Institution",
  "Religious Organisation",
  "Religious Organization",
  "Religious School",
  "Remodeler",
  "Renovation Contractor",
  "Rental",
  "Renter\'S Insurance Agency",
  "Repair Service",
  "Repairs",
  "Reproductive Health Clinic",
  "Reptile Store",
  "Rescue Squad",
  "Research And Product Development",
  "Research Engineer",
  "Research Foundation",
  "Research Institute",
  "Reservoir",
  "Resident Registration Office",
  "Residential Building",
  "Residential College",
  "Residents Association",
  "Resort",
  "Resort Hotel",
  "Rest Stop",
  "Restaurant",
  "Restaurant Or Cafe",
  "Restaurant Supply Store",
  "Resume Service",
  "Retail Space Rental Agency",
  "Retaining Wall Supplier",
  "Retirement Community",
  "Retirement Home",
  "Retreat Center",
  "Rheumatologist",
  "Rice Cake Shop",
  "Rice Mill",
  "Rice Restaurant",
  "Rice Shop",
  "Rice Wholesaler",
  "Ridge",
  "River",
  "River Confluence",
  "River Port",
  "Road Construction Company",
  "Road Construction Machine Repair Service",
  "Road Cycling",
  "Road Safety Town",
  "Roads Ports And Canals Engineers Association",
  "Rock",
  "Rock Climbing",
  "Rock Climbing Gym",
  "Rock Climbing Instructor",
  "Rock Music Club",
  "Rock Shop",
  "Rodeo",
  "Rolled Metal Products Supplier",
  "Roller Coaster",
  "Roller Skating Club",
  "Roller Skating Rink",
  "Rolls-Royce Dealer",
  "Roman Restaurant",
  "Romanian Restaurant",
  "Roofing Contractor",
  "Roofing Supply Store",
  "Room",
  "Roommate Referral Service",
  "Rowing Area",
  "Rowing Club",
  "Rubber Products Supplier",
  "Rubber Stamp Store",
  "Rug Store",
  "Rugby",
  "Rugby Club",
  "Rugby Field",
  "Ruin",
  "Running Store",
  "Russian Grocery Store",
  "Russian Orthodox Church",
  "Russian Restaurant",
  "Rustic Furniture Store",
  "Rv Dealer",
  "Rv Park",
  "Rv Repair Shop",
  "Rv Storage Facility",
  "Rv Supply Store",
  "Saab Dealer",
  "Sacem",
  "Saddlery",
  "Safe & Vault Shop",
  "Safety Equipment Supplier",
  "Sailing Club",
  "Sailing Event Area",
  "Sailing School",
  "Sailmaker",
  "Sake Brewery",
  "Salad Shop",
  "Salsa Bar",
  "Salsa Classes",
  "Salvadoran Restaurant",
  "Salvage Dealer",
  "Salvage Yard",
  "Sand & Gravel Supplier",
  "Sand Plant",
  "Sandblasting Service",
  "Sandwich Shop",
  "Sanitary Inspection",
  "Sanitation Service",
  "Saree Shop",
  "Satay Restaurant",
  "Satellite Communication Service",
  "Sauna",
  "Sauna Club",
  "Sauna Store",
  "Savings Bank",
  "Saw Mill",
  "Saw Sharpening Service",
  "Scaffolder",
  "Scaffolding Rental Service",
  "Scale Model Club",
  "Scale Repair Service",
  "Scale Supplier",
  "Scandinavian Restaurant",
  "Scenic Spot",
  "School",
  "School Administrator",
  "School Bus Service",
  "School Center",
  "School District Office",
  "School For The Deaf",
  "School House",
  "School Lunch Center",
  "School Supply Store",
  "Science Academy",
  "Science Museum",
  "Scientific Equipment Supplier",
  "Scooter Rental Service",
  "Scooter Repair Shop",
  "Scout Hall",
  "Scout Home",
  "Scouting",
  "Scrap Metal Dealer",
  "Scrapbooking Store",
  "Screen Printer",
  "Screen Printing Shop",
  "Screen Printing Supply Store",
  "Screen Repair Service",
  "Screen Store",
  "Screw Supplier",
  "Scuba Instructor",
  "Scuba Tour Agency",
  "Sculptor",
  "Sculpture",
  "Sculpture Museum",
  "Seafood",
  "Seafood Donburi Restaurant",
  "Seafood Farm",
  "Seafood Market",
  "Seafood Restaurant",
  "Seafood Store",
  "Seafood Wholesaler",
  "Seal Shop",
  "Seaplane Base",
  "Seaport",
  "Seasonal Goods Store",
  "Seasonal Lake",
  "Seat Dealer",
  "Second Hand Store",
  "Secondary School",
  "Security",
  "Security Guard Service",
  "Security Service",
  "Security System Installer",
  "Security System Supplier",
  "Seed Supplier",
  "Seitai",
  "Self Defense School",
  "Self Service Car Wash",
  "Self Service Health Station",
  "Self Service Restaurant",
  "Self-Catering Accommodation",
  "Self-Storage Facility",
  "Semi Conductor Supplier",
  "Seminar Room",
  "Seminary",
  "Senior Citizen Center",
  "Senior High School",
  "Septic System Service",
  "Serbian Restaurant",
  "Service Counter",
  "Service Establishment",
  "Serviced Accommodation",
  "Serviced Apartment",
  "Services",
  "Seventh-Day Adventist Church",
  "Sewage Disposal Service",
  "Sewage Treatment Plant",
  "Sewing Company",
  "Sewing Machine Repair Service",
  "Sewing Machine Store",
  "Sewing Shop",
  "Sexologist",
  "Sfiha Restaurant",
  "Shabu-Shabu Restaurant",
  "Shanghainese Restaurant",
  "Shared-Use Commercial Kitchen",
  "Sharpening Service",
  "Shawarma Restaurant",
  "Shed Builder",
  "Sheep Shearer",
  "Sheepskin And Wool Products Supplier",
  "Sheepskin Coat Store",
  "Sheet Metal Contractor",
  "Sheet Music Store",
  "Shelter",
  "Sheltered Housing",
  "Shelving Store",
  "Sheriff\'S Department",
  "Shinto Shrine",
  "Ship Building",
  "Shipbuilding And Repair Company",
  "Shipping And Mailing",
  "Shipping And Mailing Service",
  "Shipping Company",
  "Shipping Equipment Industry",
  "Shipping Service",
  "Shipyard",
  "Shoe Factory",
  "Shoe Repair Shop",
  "Shoe Shining Service",
  "Shoe Store",
  "Shooting Event Area",
  "Shooting Range",
  "Shop",
  "Shop Supermarket Furniture Store",
  "Shopfitter",
  "Shopping Mall",
  "Short Term Apartment Rental Agency",
  "Shower Door Shop",
  "Showroom",
  "Shredding Service",
  "Shrimp Farm",
  "Shrine",
  "Shrubbery",
  "Sichuan Restaurant",
  "Sicilian Restaurant",
  "Siding Contractor",
  "Sightseeing Tour Agency",
  "Sign Shop",
  "Silk Plant Shop",
  "Silk Store",
  "Silversmith",
  "Singaporean Restaurant",
  "Singing Telegram Service",
  "Single Sex Secondary School",
  "Singles Organization",
  "Skate Sharpening Service",
  "Skate Shop",
  "Skateboard Park",
  "Skateboard Shop",
  "Skating Instructor",
  "Skeet Shooting Range",
  "Ski Club",
  "Ski Rental Service",
  "Ski Repair Service",
  "Ski Resort",
  "Ski School",
  "Ski Shop",
  "Skin Care Clinic",
  "Skin Care Products Vending Machine",
  "Skittle Club",
  "Skydiving Center",
  "Skylight Contractor",
  "Slaughterhouse",
  "Sleep Clinic",
  "Slope",
  "Small Appliance Repair Service",
  "Small Claims Assistance Service",
  "Small Engine Repair Service",
  "Small Plates Restaurant",
  "Smart Car Dealer",
  "Smart Dealer",
  "Smart Shop",
  "Smog Inspection Station",
  "Smoke Shop",
  "Snack Bar",
  "Snow Removal Service",
  "Snowboard Rental Service",
  "Snowboard Shop",
  "Snowmobile Dealer",
  "Snowmobile Rental Service",
  "Soapland",
  "Soba Noodle Shop",
  "Soccer",
  "Soccer Club",
  "Soccer Field",
  "Soccer Practice",
  "Soccer Store",
  "Social Club",
  "Social Security Attorney",
  "Social Security Financial Department",
  "Social Security Office",
  "Social Services",
  "Social Services Organization",
  "Social Welfare Center",
  "Social Worker",
  "Sod Supplier",
  "Sofa Store",
  "Soft Drinks Shop",
  "Softball Club",
  "Softball Field",
  "Software Company",
  "Software Training Institute",
  "Soil Testing Service",
  "Solar Energy Company",
  "Solar Energy Contractor",
  "Solar Energy Equipment Supplier",
  "Solar Hot Water System Supplier",
  "Solar Photovoltaic Power Plant",
  "Solid Fuel Company",
  "Solid Waste Engineer",
  "Soul Food Restaurant",
  "Soup Kitchen",
  "Soup Restaurant",
  "Soup Shop",
  "South African Restaurant",
  "South American Restaurant",
  "South Asian Restaurant",
  "South Indian Restaurant",
  "Southeast Asian Restaurant",
  "Southern Italian Restaurant",
  "Southern Restaurant (Us)",
  "Southwestern Restaurant (Us)",
  "Souvenir Manufacturer",
  "Souvenir Store",
  "Soy Sauce Maker",
  "Spa",
  "Spa And Health Club",
  "Spa Garden",
  "Spa Town",
  "Space Of Remembrance",
  "Spanish Restaurant",
  "Special Education School",
  "Specialized Clinic",
  "Specialized Hospital",
  "Speech Pathologist",
  "Sperm Bank",
  "Spice Store",
  "Spice Wholesaler",
  "Spices Exporter",
  "Spices Wholesalers",
  "Spiritist Center",
  "Sport Tour Agency",
  "Sporting Goods Store",
  "Sports",
  "Sports Accessories Wholesaler",
  "Sports Activity Location",
  "Sports Bar",
  "Sports Card Store",
  "Sports Club",
  "Sports Complex",
  "Sports Equipment Rental Service",
  "Sports Injury Clinic",
  "Sports Massage Therapist",
  "Sports Medicine Clinic",
  "Sports Medicine Physician",
  "Sports Memorabilia Store",
  "Sports Nutrition Store",
  "Sports School",
  "Sportswear Store",
  "Sportwear Manufacturer",
  "Spring",
  "Spring Supplier",
  "Squash Club",
  "Squash Court",
  "Sri Lankan Restaurant",
  "Stable",
  "Stadium",
  "Staffing Agency",
  "Stage",
  "Stage Lighting Equipment Supplier",
  "Stained Glass Studio",
  "Stainless Steel Plant",
  "Stair Contractor",
  "Stall Installation Service",
  "Stamp Collectors Club",
  "Stamp Shop",
  "Stand Bar",
  "Staple Food Package",
  "State Archive",
  "State Department Agriculture Food Supply",
  "State Department Finance",
  "State Department For Social Development",
  "State Department Housing And Urban Development",
  "State Department Of Agricultural Development",
  "State Department Of Environment",
  "State Department Of Tourism",
  "State Department Of Transportation",
  "State Department Science Technology",
  "State Employment Department",
  "State Government Office",
  "State Liquor Store",
  "State Office Of Education",
  "State Owned Farm",
  "State Park",
  "State Police",
  "Stationery Manufacturer",
  "Stationery Store",
  "Stationery Wholesaler",
  "Statuary",
  "Statue",
  "Std Clinic",
  "Std Testing Service",
  "Steak House",
  "Steamboat Restaurant",
  "Steamed Bun Shop",
  "Steel Construction Company",
  "Steel Distributor",
  "Steel Drum Supplier",
  "Steel Erector",
  "Steel Fabricator",
  "Steel Framework Contractor",
  "Steelwork Design Company",
  "Steelwork Manufacturer",
  "Stereo Rental Store",
  "Stereo Repair Service",
  "Sticker Manufacturer",
  "Stitching Class",
  "Stock Broker",
  "Stock Exchange Building",
  "Stone Carving",
  "Stone Cutter",
  "Stone Supplier",
  "Storage",
  "Storage Facility",
  "Store",
  "Store Equipment Supplier",
  "Stores And Shopping",
  "Stove Builder",
  "Strait",
  "Stringed Instrument Maker",
  "Structural Engineer",
  "Stucco Contractor",
  "Student Career Counseling Office",
  "Student Dormitory",
  "Student Housing Center",
  "Student Union",
  "Students Parents Association",
  "Students Support Association",
  "Studio",
  "Study At Home School",
  "Studying Center",
  "Stylist",
  "Subaru Dealer",
  "Suburban Train Line",
  "Subway Station",
  "Sugar Factory",
  "Sugar Shack",
  "Sukiyaki And Shabu Shabu Restaurant",
  "Summer Camp",
  "Sundae Restaurant",
  "Sunglasses Store",
  "Sunroom Contractor",
  "Super Public Bath",
  "Superannuation Consultant",
  "Superfund Site",
  "Superior Courts",
  "Supermarket",
  "Suppon Restaurant",
  "Support Group",
  "Supreme Court",
  "Surf Lifesaving Club",
  "Surf School",
  "Surf Shop",
  "Surgeon",
  "Surgical Center",
  "Surgical Oncologist",
  "Surgical Products Wholesaler",
  "Surgical Supply Store",
  "Surplus Store",
  "Surveyor",
  "Sushi Restaurant",
  "Sushi Takeaway",
  "Suzuki Dealer",
  "Suzuki Motorcycle Dealer",
  "Swedish Restaurant",
  "Sweets And Dessert Buffet",
  "Swim Club",
  "Swimming",
  "Swimming Basin",
  "Swimming Competition",
  "Swimming Facility",
  "Swimming Instructor",
  "Swimming Lake",
  "Swimming Pool",
  "Swimming Pool Contractor",
  "Swimming Pool Repair Service",
  "Swimming Pool Supply Store",
  "Swimming School",
  "Swimwear Store",
  "Swiss Restaurant",
  "Synagogue",
  "Syokudo And Teishoku Restaurant",
  "Syrian Restaurant",
  "T-Shirt Company",
  "T-Shirt Store",
  "Table Tennis Club",
  "Table Tennis Facility",
  "Table Tennis Supply Store",
  "Tack Shop",
  "Taco Restaurant",
  "Taekwondo Competition Area",
  "Taekwondo School",
  "Tag Agency",
  "Tai Chi School",
  "Tailor",
  "Taiwanese Restaurant",
  "Takeout Restaurant",
  "Talent Agency",
  "Tamale Shop",
  "Tannery",
  "Tanning Salon",
  "Taoist Temple",
  "Tapas Bar",
  "Tapas Restaurant",
  "Tattoo And Piercing Shop",
  "Tattoo Artist",
  "Tattoo Removal Service",
  "Tattoo Shop",
  "Tax",
  "Tax Assessor",
  "Tax Attorney",
  "Tax Collector\'S Office",
  "Tax Consultant",
  "Tax Department",
  "Tax Preparation",
  "Tax Preparation Service",
  "Taxi Service",
  "Taxicab Stand",
  "Taxidermist",
  "Tb Clinic",
  "Tea Exporter",
  "Tea House",
  "Tea Manufacturer",
  "Tea Market Place",
  "Tea Store",
  "Tea Wholesaler",
  "Teacher College",
  "Technical Education Academy",
  "Technical School",
  "Technical Service",
  "Technical University",
  "Technology Museum",
  "Technology Park",
  "Teeth Whitening Service",
  "Telecommunication School",
  "Telecommunications",
  "Telecommunications Contractor",
  "Telecommunications Engineer",
  "Telecommunications Equipment Supplier",
  "Telecommunications Service Provider",
  "Telemarketing Service",
  "Telephone Answering Service",
  "Telephone Company",
  "Telephone Exchange",
  "Telescope Store",
  "Television Repair Service",
  "Television Station",
  "Temp Agency",
  "Tempura Restaurant",
  "Tenant Ownership",
  "Tenant\'S Union",
  "Tennis Club",
  "Tennis Court",
  "Tennis Court Construction Company",
  "Tennis Instructor",
  "Tennis Store",
  "Tent Rental Service",
  "Teppanyaki Restaurant",
  "Terminal Point",
  "Terrain",
  "Tesla Showroom",
  "Tex-Mex Restaurant",
  "Textile Engineer",
  "Textile Exporter",
  "Textile Mill",
  "Textiles",
  "Thai Massage Therapist",
  "Thai Restaurant",
  "Theater Company",
  "Theater Production",
  "Theater Supply Store",
  "Theatrical Costume Supplier",
  "Theme Park",
  "Therapists",
  "Thermal Baths",
  "Thermal Power Plant",
  "Thread Supplier",
  "Threads And Yarns Wholesaler",
  "Thrift Store",
  "Tibetan Restaurant",
  "Tiffin Center",
  "Tiki Bar",
  "Tile Contractor",
  "Tile Manufacturer",
  "Tile Store",
  "Timeshare Agency",
  "Tire Repair Shop",
  "Tire Shop",
  "Title Company",
  "Tobacco Exporter",
  "Tobacco Shop",
  "Tobacco Supplier",
  "Tofu Restaurant",
  "Tofu Shop",
  "Toiletries Store",
  "Toll Booth",
  "Toll Road Rest Stop",
  "Toner Cartridge Supplier",
  "Tonkatsu Restaurant",
  "Tool & Die Shop",
  "Tool Grinding Service",
  "Tool Manufacturer",
  "Tool Rental Service",
  "Tool Repair Shop",
  "Tool Store",
  "Tool Wholesaler",
  "Toolroom",
  "Topography Company",
  "Topsoil Supplier",
  "Tortilla Shop",
  "Tour Agency",
  "Tour Operator",
  "Tourism",
  "Tourist Attraction",
  "Tourist Information Center",
  "Tower",
  "Tower Communication Service",
  "Towing Equipment Provider",
  "Towing Service",
  "Town Square",
  "Townhouse Complex",
  "Township Office",
  "Toy And Game Manufacturer",
  "Toy Library",
  "Toy Manufacturer",
  "Toy Museum",
  "Toy Store",
  "Toyota Dealer",
  "Tractor Dealer",
  "Tractor Repair Shop",
  "Trade Fair Construction Company",
  "Trade School",
  "Trading Card Store",
  "Traditional American Restaurant",
  "Traditional Costume Club",
  "Traditional Kostume Store",
  "Traditional Market",
  "Traditional Restaurant",
  "Traditional Teahouse",
  "Traffic Officer",
  "Traffic Police Station",
  "Trail Head",
  "Trailer Dealer",
  "Trailer Manufacturer",
  "Trailer Rental Service",
  "Trailer Repair Shop",
  "Trailer Supply Store",
  "Train Depot",
  "Train Repairing Center",
  "Train Station",
  "Train Ticket Agency",
  "Train Ticket Office",
  "Train Yard",
  "Training Centre",
  "Training Courses",
  "Training Provider",
  "Training School",
  "Tram Stop",
  "Transcription Service",
  "Transit Depot",
  "Transit Station",
  "Transit Stop",
  "Translator",
  "Transmission Shop",
  "Transplant Surgeon",
  "Transport Interchange",
  "Transportation",
  "Transportation Escort Service",
  "Transportation Infrastructure",
  "Transportation Service",
  "Travel",
  "Travel Agency",
  "Travel Clinic",
  "Travel Lounge",
  "Travel Services",
  "Travellers Lodge",
  "Tree Farm",
  "Tree Service",
  "Trial Attorney",
  "Tribal Headquarters",
  "Triumph Motorcycle Dealer",
  "Trolleybus Stop",
  "Trophy Shop",
  "Tropical Fish Store",
  "Truck Accessories Store",
  "Truck Dealer",
  "Truck Farmer",
  "Truck Parts Supplier",
  "Truck Rental Agency",
  "Truck Repair Shop",
  "Truck Stop",
  "Truck Topper Supplier",
  "Trucking",
  "Trucking Company",
  "Trucking School",
  "Truss Manufacturer",
  "Trust Bank",
  "Tsukigime Parking Lot",
  "Tuning Automobile",
  "Tunisian Restaurant",
  "Tunnel",
  "Turf Supplier",
  "Turkish Restaurant",
  "Turnery",
  "Tuscan Restaurant",
  "Tutoring Service",
  "Tuxedo Shop",
  "Typewriter Repair Service",
  "Typewriter Supplier",
  "Typing Service",
  "Tyre Manufacturer",
  "Udon Noodle Restaurant",
  "Ukrainian Restaurant",
  "Unagi Restaurant",
  "Underwear Store",
  "Unemployment Office",
  "Unfinished Furniture Store",
  "Uniform Store",
  "Unitarian Universalist Church",
  "United Church Of Christ",
  "United Methodist Church",
  "United States Armed Forces Base",
  "Unity Church",
  "University",
  "University Department",
  "University Hospital",
  "University Lab Room",
  "University Library",
  "Upholstery Cleaning Service",
  "Upholstery Shop",
  "Urban Planning Department",
  "Urgent Care Center",
  "Urologist",
  "Urology Clinic",
  "Uruguayan Restaurant",
  "Used Appliance Store",
  "Used Auto Parts Store",
  "Used Bicycle Shop",
  "Used Book Store",
  "Used Car Dealer",
  "Used Cd Store",
  "Used Clothing Store",
  "Used Computer Store",
  "Used Furniture Store",
  "Used Game Store",
  "Used Motorcycle Dealer",
  "Used Musical Instrument Store",
  "Used Office Furniture Store",
  "Used Store Fixture Supplier",
  "Used Tire Shop",
  "Used Truck Dealer",
  "Utility Contractor",
  "Utility Trailer Dealer",
  "Uzbeki Restaurant",
  "Vacation Home Rental Agency",
  "Vacuum Cleaner Repair Shop",
  "Vacuum Cleaner Store",
  "Vacuum Cleaning System Supplier",
  "Valet Parking Service",
  "Valeting Service",
  "Van Rental Agency",
  "Vaporizer Store",
  "Variety Store",
  "Vascular Surgeon",
  "Vastu Consultant",
  "Vcr Repair Service",
  "Vegan Restaurant",
  "Vegetable Wholesale Market",
  "Vegetable Wholesaler",
  "Vegetarian Cafe And Deli",
  "Vegetarian Restaurant",
  "Vegetation",
  "Vehicle Examination Office",
  "Vehicle Exporter",
  "Vehicle Inspection",
  "Vehicle Rental",
  "Vehicle Shipping Agent",
  "Vehicle Wrapping Service",
  "Velodrome",
  "Vending Machine",
  "Vending Machine Supplier",
  "Venereologist",
  "Venezuelan Restaurant",
  "Ventilating Equipment Manufacturer",
  "Venture Capital Company",
  "Veterans",
  "Veterans Affairs Department",
  "Veterans Center",
  "Veterans Hospital",
  "Veterans Organization",
  "Veterans\' Organization",
  "Veterinarian",
  "Veterinary Care",
  "Veterinary Pharmacy",
  "Video",
  "Video Arcade",
  "Video Camera Repair Service",
  "Video Conferencing Equipment Supplier",
  "Video Conferencing Service",
  "Video Duplication Service",
  "Video Editing Service",
  "Video Equipment Repair Service",
  "Video Game Rental Kiosk",
  "Video Game Rental Service",
  "Video Game Rental Store",
  "Video Game Store",
  "Video Karaoke",
  "Video Production Service",
  "Video Store",
  "Vietnamese Restaurant",
  "Villa",
  "Village Hall",
  "Vineyard",
  "Vineyard Church",
  "Vintage Clothing Store",
  "Vinyl Sign Shop",
  "Violin Shop",
  "Virtual Office Rental",
  "Visa And Passport Office",
  "Visa Consultant",
  "Visitor Center",
  "Vista",
  "Vista Point",
  "Vitamin & Supplements Store",
  "Vocal Instructor",
  "Vocational College",
  "Vocational School",
  "Vocational School One",
  "Volcano",
  "Volkswagen Dealer",
  "Volleyball Club",
  "Volleyball Court",
  "Volleyball Instructor",
  "Volunteer Organization",
  "Volvo Dealer",
  "Voter Registration Office",
  "Voting Location",
  "Waldorf Kindergarten",
  "Waldorf School",
  "Walk-In Clinic",
  "Wallpaper Installer",
  "Wallpaper Store",
  "War Memorial",
  "War Museum",
  "Warehouse",
  "Warehouse Club",
  "Warehouse Store",
  "Washer & Dryer Repair Service",
  "Washer & Dryer Store",
  "Waste Management Service",
  "Watch Manufacturer",
  "Watch Repair Service",
  "Watch Store",
  "Water",
  "Water Cooler Supplier",
  "Water Damage Restoration Service",
  "Water Filter Supplier",
  "Water Jet Cutting Service",
  "Water Mill",
  "Water Park",
  "Water Polo Pool",
  "Water Pump Supplier",
  "Water Purification Company",
  "Water Ski Shop",
  "Water Skiing Club",
  "Water Skiing Instructor",
  "Water Skiing Service",
  "Water Softening Equipment Supplier",
  "Water Sports",
  "Water Sports Equipment Rental Service",
  "Water Tank Cleaning Service",
  "Water Testing Service",
  "Water Treatment Plant",
  "Water Treatment Supplier",
  "Water Utility Company",
  "Water Works",
  "Water Works Equipment Supplier",
  "Waterbed Store",
  "Waterfall",
  "Watering Hole",
  "Waterproofing Company",
  "Wax Museum",
  "Wax Supplier",
  "Waxing Hair Removal Service",
  "Weather Forecast Service",
  "Weaving Mill",
  "Web Hosting Company",
  "Webcam Location",
  "Website Designer",
  "Wedding Bakery",
  "Wedding Buffet",
  "Wedding Chapel",
  "Wedding Dress Rental Service",
  "Wedding Photographer",
  "Wedding Planner",
  "Wedding Service",
  "Wedding Souvenir Shop",
  "Wedding Store",
  "Wedding Venue",
  "Weddings",
  "Weigh Station",
  "Weight Loss Service",
  "Weightlifting Area",
  "Weir",
  "Welder",
  "Welding",
  "Welding Gas Supplier",
  "Welding Supply Store",
  "Well",
  "Well Drilling Contractor",
  "Wellness Center",
  "Wellness Hotel",
  "Wellness Program",
  "Wesleyan Church",
  "West African Restaurant",
  "Western Apparel Store",
  "Western Food",
  "Western Restaurant",
  "Wetland",
  "Whale Watching Tour Agency",
  "Wheel Alignment Service",
  "Wheel Store",
  "Wheelchair Rental Service",
  "Wheelchair Repair Service",
  "Wheelchair Store",
  "Wholesale Bakery",
  "Wholesale Drugstore",
  "Wholesale Florist",
  "Wholesale Food Store",
  "Wholesale Grocer",
  "Wholesale Jeweler",
  "Wholesale Market",
  "Wholesale Plant Nursery",
  "Wholesaler",
  "Wholesaler Household Appliances",
  "Wi-Fi Spot",
  "Wicker Store",
  "Wig Shop",
  "Wilderness Center",
  "Wildlife And Safari Park",
  "Wildlife Park",
  "Wildlife Refuge",
  "Wildlife Rescue Service",
  "Willow Basket Manufacturer",
  "Wind Farm",
  "Wind Turbine Builder",
  "Window Cleaning Service",
  "Window Installation Service",
  "Window Supplier",
  "Window Tinting Service",
  "Window Treatment Store",
  "Windsurfing Store",
  "Wine",
  "Wine Bar",
  "Wine Cellar",
  "Wine Club",
  "Wine Storage Facility",
  "Wine Store",
  "Wine Wholesaler And Importer",
  "Winemaking Supply Store",
  "Winery",
  "Wing Chun School",
  "Wok Restaurant",
  "Women\'S Clothing Store",
  "Women\'S College",
  "Women\'S Health Clinic",
  "Women\'S Organization",
  "Women\'S Personal Trainer",
  "Women\'S Shelter",
  "Womens College",
  "Womens Personal Trainer",
  "Womens Protection Service",
  "Wood And Laminate Flooring Supplier",
  "Wood Floor Installation Service",
  "Wood Floor Refinishing Service",
  "Wood Frame Supplier",
  "Wood Industry",
  "Wood Stove Shop",
  "Wood Supplier",
  "Wood Working Class",
  "Woods",
  "Woodworker",
  "Woodworking Supply Store",
  "Wool Store",
  "Work Clothes Store",
  "Workers\' Club",
  "Working Womens Hostel",
  "Wrestling School",
  "X-Ray Equipment Supplier",
  "X-Ray Lab",
  "Yacht Broker",
  "Yacht Club",
  "Yakiniku Restaurant",
  "Yakitori Restaurant",
  "Yamaha Motorcycle Dealer",
  "Yarn Store",
  "Yemeni Restaurant",
  "Yemenite Restaurant",
  "Yeshiva",
  "Yoga Instructor",
  "Yoga Retreat Center",
  "Yoga Studio",
  "Youth Care",
  "Youth Center",
  "Youth Clothing Store",
  "Youth Club",
  "Youth Group",
  "Youth Hostel",
  "Youth Organization",
  "Youth Social Services Organization",
  "Yucatan Restaurant",
  "Zhejiang Restaurant",
  "Zoo",
];


export const US_STATES = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "DC", name: "District of Columbia" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" }
];

export const COUNTRIES = [
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "GB", name: "United Kingdom" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "IE", name: "Ireland" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "CH", name: "Switzerland" },
  { code: "AT", name: "Austria" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "GR", name: "Greece" },
  { code: "CZ", name: "Czech Republic" },
  { code: "HU", name: "Hungary" },
  { code: "RO", name: "Romania" },
  { code: "IN", name: "India" },
  { code: "SG", name: "Singapore" },
  { code: "MY", name: "Malaysia" },
  { code: "PH", name: "Philippines" },
  { code: "ID", name: "Indonesia" },
  { code: "TH", name: "Thailand" },
  { code: "VN", name: "Vietnam" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "HK", name: "Hong Kong" },
  { code: "TW", name: "Taiwan" },
  { code: "CN", name: "China" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "QA", name: "Qatar" },
  { code: "KW", name: "Kuwait" },
  { code: "BH", name: "Bahrain" },
  { code: "OM", name: "Oman" },
  { code: "IL", name: "Israel" },
  { code: "TR", name: "Turkey" },
  { code: "EG", name: "Egypt" },
  { code: "ZA", name: "South Africa" },
  { code: "NG", name: "Nigeria" },
  { code: "KE", name: "Kenya" },
  { code: "GH", name: "Ghana" },
  { code: "MA", name: "Morocco" },
  { code: "MX", name: "Mexico" },
  { code: "BR", name: "Brazil" },
  { code: "AR", name: "Argentina" },
  { code: "CL", name: "Chile" },
  { code: "CO", name: "Colombia" },
  { code: "PE", name: "Peru" },
  { code: "UY", name: "Uruguay" },
];
